{
  "Actions": {
    "actions": "Actions",
    "back": "Retour",
    "click here": "Cliquez ici",
    "collapse": "Réduire",
    "expand": "Agrandir",
    "go to vehicle": "Aller au véhicule"
  },
  "Alert": {
    "Account is already activated": "Compte déjà activé.",
    "action failed": "Échec de l'action en raison d'une erreur",
    "add company card success": "Nouvelle carte entreprise ajoutée avec succès.",
    "add driver success": "Conducteur ajouté avec succès",
    "add integration success": "Intégration créée avec succès.",
    "add vehicle empty imei info": {
      "description": "Le véhicule n'a pas d'IMEI attribué et ne pourra pas télécharger de fichiers. Ajoutez un IMEI valide pour télécharger les fichiers du véhicule.",
      "title": "Véhicule ajouté avec succès, mais aucun IMEI attribué."
    },
    "add vehicle success": "Véhicule ajouté avec succès",
    "An unhandled error occured while processing this request": "Une erreur non gérée s'est produite lors du traitement de cette requête.",
    "Another driver is registered under this card number.": "Un autre conducteur est enregistré sous ce numéro de carte.",
    "apply all driver schedules success": "Le calendrier a été ajouté avec succès pour tous les conducteurs.",
    "apply all vehicle schedules success": "Le calendrier a été ajouté avec succès à tous les véhicules.",
    "apply driver schedules success": "Le calendrier a été ajouté avec succès pour {{resourceCount}} conducteurs.",
    "apply vehicle schedules success": "Le calendrier a été ajouté avec succès à {{resourceCount}} véhicules.",
    "cancel invitation success": "L'invitation a été annulée avec succès.",
    "Card number must be 16 characters in length.": "L'identifiant du conducteur doit comporter 16 caractères.",
    "CCA file download success": "Authentificateur de la carte entreprise a été téléchargé avec succès.",
    "Comment must not be longer than 255 characters.": "Le nombre de caractères autorisés pour la description est de 255.",
    "Company card with such ID already exists.": "Une carte entreprise avec cet identifiant existe déjà.",
    "Company card with such name already exists.": "Une carte entreprise avec ce nom existe déjà.",
    "Company not found": "Entreprise introuvable.",
    "Company not found.": "Entreprise introuvable.",
    "Company with this LZ client code already exists.": "Une entreprise portant ce code Teltonika existe déjà.",
    "create client company success": "Création réussie d'une nouvelle entreprise cliente.",
    "create company success": "Entreprise créée avec succès.",
    "create schedule success": "Nouveau calendrier créé avec succès.",
    "credits overdraft activated": "Le découvert de crédit a été activé avec succès",
    "credits overdraft deactivated": "Le découvert crédit a été désactivé avec succès",
    "disable integration success": "L'intégration a été désactivée avec succès.",
    "Driver duplication.": "Duplication des conducteurs.",
    "Driver name contains invalid characters.": "Le nom du conducteur contient des caractères non valides.",
    "Driver name must be 3-50 characters long.": "Le nom du conducteur doit comporter entre 3 et 50 caractères.",
    "Driver with such card number already exists.": "L'identifiant du conducteur existe déjà.",
    "Drivers schedules were not found": "Les calendriers des conducteurs n'ont pas été trouvés.",
    "edit company card success": "La fiche de l'entreprise a été modifiée avec succès.",
    "edit integration success": "Intégration modifiée avec succès.",
    "edit schedule success": "Calendrier modifié avec succès.",
    "edit user description": "Les modifications prendront effet une fois que l'utilisateur ayant effectué les modifications se sera déconnecté.",
    "Email recipient was not found.": "Le destinataire est introuvable.",
    "email transfer edit recipient success": "Le destinataire a été modifié avec succès.",
    "email transfer new recipient success": "Le destinataire a été ajouté avec succès.",
    "email transfer remove recipient success": "Le destinataire a été supprimé avec succès.",
    "enable integration success": "L'intégration a été activée avec succès.",
    "error": {
      "import failed": "Échec de l'importation du fichier. Supprimez le fichier, assurez-vous que les données correspondent à la structure requise, puis téléchargez-le à nouveau.",
      "import failed description": "Supprimez le fichier, assurez-vous que les données correspondent à la structure requise, puis téléchargez à nouveau le fichier.",
      "import failed title": "Échec de l'importation. Les données ne correspondent pas à la structure du fichier."
    },
    "general settings update success": "Les paramètres ont été modifiés avec succès.",
    "global schedule success": "Le calendrier global a été créé avec succès.",
    "Id must be of digits and letters only": "L'identifiant doit être composé uniquement de chiffres et de lettres",
    "Id must be of length 6 to 8": "L'identifiant doit comporter entre 6 et 8 caractères",
    "Imei must be 15 characters long.": "L'IMEI doit comporter 15 caractères.",
    "Imei must be numeric.": "Seules les valeurs numériques sont autorisées dans le champ IMEI.",
    "integration editing cancelled": "Modification de l'intégration annulée.",
    "Integration is disabled. Enable it first before retrying": "L'intégration est désactivée. Veuillez l'activer avant de réessayer.",
    "Invalid email address": "Adresse e-mail invalide.",
    "Invalid format.": "Format de fichier non valide",
    "LZ client code not found.": "Code Teltonika introuvable.",
    "move company success": "La société « {{sourceCompany}} » a été transférée avec succès vers « {{targetCompany}} ».",
    "New name must be different from the current name.": "Le nouveau nom doit etre différent du nom actuel.",
    "news created": "Actualité créée avec succès.",
    "news deleted": "Actualité supprimée avec succès.",
    "news edited": "Actualité modifiée avec succès.",
    "news published": "Actualité publiée avec succès.",
    "Number must be provided.": "Le numéro doit être fourni.",
    "Number must not be longer than 30 characters.": "Le nombre de caractères autorisé pour le numéro d'immatriculation est de 30.",
    "One or more selected companies have child companies and cannot be deleted.": "Une ou plusieurs des entreprises sélectionnées ont des filiales et ne peuvent pas être supprimées.",
    "One or more validation errors occured while parsing csv file Please use template file for reference.": "Une ou plusieurs erreurs de validation se sont produites lors de l'analyse du fichier CSV. Veuillez utiliser le fichier modèle comme référence.",
    "One or more validation errors occured.": "Une ou plusieurs erreurs de validation se sont produites.",
    "quick schedule created": {
      "description": {
        "drivers": "Le téléchargement des données sera lancé dès que la connexion du conducteur à TachoSync sera détectée.",
        "vehicles": "Le téléchargement des données sera lancé dès que la connexion du véhicule à TachoSync sera détectée."
      },
      "title": "Le calendrier rapide a été créé avec succès.",
      "title multiple drivers": "Le calendrier rapide a été créé avec succès pour {{driverNum}} conducteurs.",
      "title multiple vehicles": "Le calendrier rapide a été créé avec succès pour {{vehicleNum}} véhicules.",
      "title single driver": "Le calendrier rapide a été créé avec succès."
    },
    "Quick schedule for vehicle is already created.": "Un calendrier rapide pour le véhicule a déjà été créé.",
    "Quick schedule is already assigned to the driver.": "Un planning rapide a déjà été attribué au conducteur.",
    "remove company card success": "Carte entreprise retirée avec succès.",
    "resend invitation success": "L'invitation a été renvoyée avec succès.",
    "retry integration success": "L'intégration « {{integrationName}} » a été connectée avec succès.",
    "retry interrupted integration success": "L'intégration « {{integrationName}} » va réessayer de synchroniser les fichiers ignorés. Veuillez revenir plus tard pour vérifier l'état.",
    "session expired": "Votre session a expiré. Veuillez vous reconnecter.",
    "successfully activate vehicle multiple": "{{resourceString}} véhicules activés avec succès.",
    "successfully activate vehicle single": "Le véhicule a été activé avec succès.",
    "successfully assigned schedules": {
      "multiple": "Horaires attribués avec succès.",
      "single": "Le planning a été attribué avec succès."
    },
    "successfully deactivate vehicle multiple": "{{resourceString}} véhicules désactivés avec succès.",
    "successfully deactivate vehicle single": "Le véhicule a été désactivé avec succès.",
    "successfully deleted": "{{resourceString}} supprimé avec succès.",
    "successfully edited": "{{resourceString}} modifié avec succès.",
    "successfully exported": "$t(General##{{tableName}}) a été exporté avec succès.",
    "successfully imported": "{{resourceString}} importé avec succès.",
    "successfully move vehicles multiple": "{{resourceString}} ont été transféré avec succès vers {{companyString}}.",
    "successfully move vehicles single": "{{resourceString}} a été transféré avec succès vers {{companyString}}.",
    "successfully remove driver schedules multiple": "Les calendriers ont été supprimés avec succès des conducteurs {{resourceString}}.",
    "successfully remove driver schedules single": "Les calendriers ont été supprimés avec succès du conducteur {{resourceString}}.",
    "successfully remove vehicle schedules multiple": "Les calendriers ont été supprimés avec succès des véhicules {{resourceString}}.",
    "successfully remove vehicle schedules single": "Les calendriers ont été supprimés avec succès du véhicule {{resourceString}}.",
    "successfully removed": "{{resourceString}} a été supprimé avec succès.",
    "The company with such name already exists.": "Une entreprise portant ce nom existe déjà.",
    "User is already invited.": "L'utilisateur a déja été invité.",
    "User is not invited": "L'utilisateur n'est pas invité.",
    "Vehicle duplication.": "Duplication de véhicules.",
    "Vehicle number contains invalid characters.": "Le numéro du véhicule contient des caractères non valides.",
    "Vehicle schedule was not found": "Le planning des véhicules est introuvable.",
    "Vehicle successfully activated": "Véhicule activé avec succès.",
    "Vehicle with such IMEI already exists.": "Un véhicule avec cet IMEI existe déjà",
    "Vehicle with such Imei number already exists.": "L'IMEI existe déjà.",
    "Vehicle with such number (VRN) already exists.": "Un véhicule portant ce numéro d'immatriculation existe déjà",
    "Vehicles schedules were not found": "Les planings des véhicules sont introuvables.",
    "You cannot delete a company you are a member of.": "Vous ne pouvez pas supprimer une entreprise qui est actuellement sélectionnée. Veuillez sélectionner une autre entreprise et répéter l'opération."
  },
  "Auth": {
    "account verification": {
      "check autheticator": "Vérifiez votre application d'authentification",
      "check email": "Consultez votre e-mail",
      "code required": "Code de vérification requis.",
      "code sent to email": "Code envoyé à votre adresse e-mail",
      "code valid": "Le code est valable pour plusieurs minutes.",
      "enter code below": "et saisissez le code ci-dessous pour vous connecter."
    },
    "account verification description": "Code de vérification requis. Vérifiez votre application d'authentification et saisissez le code ci-dessous pour vous connecter.",
    "authenticator": "Application d'authentification",
    "authenticator verification description": "Code de vérification requis. Consultez votre application d'authentification et saisissez le code ci-dessous pour vous connecter.",
    "back to sign in screen": "Retour à l'écran de connexion",
    "check email": "Veuillez vérifier votre boîte e-mail et cliquer sur le lien reçu pour réinitialiser votre mot de passe.",
    "community forum": "Forum de support communautaire",
    "contact us": "Contactez-nous",
    "create password": "Créer un mot de passe",
    "did not receive": "Vous n'avez pas reçu le lien ?",
    "do not have account": "Vous n'avez pas encore de compte ?",
    "email": "E-mail",
    "enter current password": "Entrez le mot de passe actuel",
    "enter email": "Veuillez saisir ci-dessous l'adresse e-mail que vous avez enregistrée pour recevoir les instructions de réinitialisation du mot de passe.",
    "enter here": "Entrez ici",
    "enter new password": "Entrer un nouveau mot de passe",
    "enter numbers only": "Veuillez saisir uniquement des chiffres (0-9)",
    "example": "Par exemple :",
    "failed to login": "L'adresse e-mail ou le mot de passe que vous avez saisi(e) est incorrect(e).",
    "forgot password": "Mot de passe oublié ?",
    "forgot your password": "Mot de passe oublié ?",
    "go to login": "Aller à la connexion",
    "google authenticator": "Google Authenticator",
    "hide password": "Masquer le mot de passe",
    "invalid email format": "Format d'adresse e-mail non valide",
    "invalid password format": "Format de mot de passe incorrect",
    "Invitation expired": "Le lien d'invitation a expiré ou a été annulé.",
    "link sent": "Le lien a été envoyé !",
    "login title": "Connexion",
    "microsoft authenticator": "Microsoft Authenticator",
    "new password": "Nouveau mot de passe",
    "password": "Mot de passe",
    "password changed": "Mot de passe modifié avec succès.",
    "privacy policy": "En utilisant <1>TachoSync</1>, vous acceptez notre <3>politique de confidentialité</3>.",
    "remember password": "Vous vous souvenez de votre mot de passe ?",
    "repeat new password": "Confirmez le nouveau mot de passe",
    "repeat password": "Confirmez votre mot de passe",
    "required": "Obligatoire",
    "resend": "Renvoyer",
    "reset password": "Réinitialiser le mot de passe",
    "send reset link": "Envoyer un lien de réinitialisation",
    "show password": "Afficher le mot de passe",
    "sign in": "Se connecter",
    "sign in to tacho": "Connectez-vous à votre\ncompte TachoSync",
    "sign out": "Se déconnecter",
    "sign up": "S'inscrire",
    "teltonika telematics": "Teltonika Telematics",
    "terms and conditions": "Je comprends et j'accepte les <1>Conditions d'utilisation de </1>Teltonika et l'<2>Accord sur le </2>traitement des données.",
    "wiki": "Base de connaissances Wiki Telematics"
  },
  "Button": {
    "accept": "Accepter",
    "accept all": "Tout accepter",
    "accept selected": "Accepter la sélection",
    "actions": "Actions",
    "activate": "Activer",
    "add": "Ajouter",
    "add driver": "Ajouter un conducteur",
    "add integration": "Ajouter une intégration",
    "add to schedule": "Ajouter au calendrier",
    "add vehicle": "Ajouter un véhicule",
    "all drivers": "Tous les conducteurs",
    "all vehicles": "Tous les véhicules",
    "apply": "Appliquer",
    "assign": "Attribuer",
    "back": "Retour",
    "back to sign in": "Retour à la connexion",
    "cancel": "Annuler",
    "change": "Modifier",
    "child company": "Filiale",
    "clear": "Effacer",
    "clear all": "Tout effacer",
    "close": "Fermer",
    "confirm": "Confirmer",
    "continue": "Continuer",
    "continue to TachoSync": "Continuer vers TachoSync",
    "copied": "Copié",
    "copy to clipboard": "Copier dans le presse-papiers",
    "create": "Créer",
    "create schedule": "Créer un calendrier",
    "deactivate": "Désactiver",
    "default view": "Affichage par défaut",
    "delete": "Supprimer",
    "deselect all": "Tout désélectionner",
    "disable": "Désactiver",
    "don't apply": "Ne pas appliquer",
    "download": "Télécharger",
    "edit": "Modifier",
    "edit driver": "Modifier le conducteur",
    "edit integration": "Modifier l'intégration",
    "edit vehicle": "Modifier le véhicule",
    "enable": "Activer",
    "export": "Exporter",
    "export drivers": "Exporter les données des conducteurs",
    "export vehicles": "Exporter les véhicules",
    "file settings": "Paramètres des fichiers",
    "filtered": "Filtré",
    "filters": "Filtres",
    "find device": "Rechercher un boitier",
    "finish": "Terminer",
    "first page": "Page d'accueil",
    "generate": "Générer",
    "generate report": "Générer un rapport",
    "get started": "Commencer",
    "go back": "Retour",
    "import": "Importer",
    "import drivers": "Importer des conducteurs",
    "import vehicles": "Importation des véhicules",
    "inline actions": {
      "cancel invitation": "Annuler l'invitation",
      "download file driver": "Télécharger",
      "download file vehicle": "Télécharger",
      "download monitoring": "Suivi des téléchargements",
      "download status": "État du téléchargement",
      "edit analysis provider": "Modifier",
      "edit company": "Modifier l'entreprise",
      "edit driver": "Modifier le conducteur",
      "edit integration": "Modifier l'intégration",
      "edit user": "Modifier l'utilisateur",
      "edit vehicle": "Modifier le véhicule",
      "resend invitation": "Renvoyer l'invitation",
      "retry analysis provider": "Réessayer",
      "retry integration": "Réessayer"
    },
    "invite": "Inviter",
    "invite user": "Inviter un utilisateur",
    "history": "Historique",
    "last page": "Page précédente",
    "max download files": "Vous ne pouvez télécharger que {{maxNumber}} fichiers à la fois.",
    "more actions": "Plus d'actions",
    "more filters": "Plus de filtres",
    "more options": "Plus d'options",
    "move": "Déplacer",
    "new client": "Nouveau client",
    "next": "Suivant",
    "next month": "Le mois prochain",
    "next page": "Page suivante",
    "only essential": "Uniquement l'essentiel",
    "open TachoSync": "Ouvrir TachoSync",
    "pages of": "sur {{total}}",
    "pause": "Pause",
    "previous": "Précédent",
    "previous month": "Mois précédent",
    "previous page": "Page précédente",
    "quick schedule": "Calendrier rapide",
    "refresh page": "Actualiser la page",
    "reject all": "Tout rejeter",
    "remove": "Supprimer",
    "remove schedules": "Supprimer les calendriers",
    "reset": "Réinitialiser",
    "reset to default": "Réinitialiser les paramètres par défaut",
    "resume": "Reprendre",
    "return home": "Retour à la page d'acceuil",
    "rows selected": "{{count}} sélectionnés",
    "save": "Enregistrer",
    "schedules": "Calendriers",
    "select image": "Sélectionner une image",
    "select rows": "Sélectionner les lignes",
    "selected": "Sélectionné",
    "send code": "Envoyer le code",
    "settings": "Paramètres",
    "table view": "Affichage sous forme de tableau",
    "testing connection": "Test de connexion...",
    "verify": "Vérifier",
    "yes": "Oui"
  },
  "Company cards": {
    "add new": "Ajouter un nouvel élément",
    "badge tooltip": {
      "Disconnected": "La connexion à TachoSync est perdue.\nDernière connexion {{connectionDate}}.",
      "Expired": "La carte est désactivée car elle a expiré.",
      "Inactive": "La connexion à TachoSync n'a jamais pu être établie.",
      "Online": "Connexion à TachoSync établie et communication active."
    },
    "card expired": "La carte a expiré : {{date}}",
    "card id": "Identifiant de la carte",
    "card number": "Numéro de carte",
    "card number tooltip": "Le numéro de carte s'affichera après la première autorisation réussie.",
    "cca version": "Version CCA",
    "company card id": "Identifiant de la carte entreprise",
    "edit card": "Modifier la carte",
    "edit company card": "Modifier la carte entreprise",
    "expiry": "Expiration",
    "expiry date": "Date d'expiration : {{date}}",
    "expiry tooltip": "La date d'expiration de la carte s'affichera après la première autorisation réussie.",
    "latest version": "Dernières versions",
    "remove card": "Supprimer la carte",
    "remove company card": "Supprimer la carte entreprise ?",
    "remove company card description": "Êtes-vous sûr de vouloir supprimer la carte entreprise « {{cardName}} » ? Cette action est irréversible.",
    "status": "Statut",
    "update version warning": "Une version plus récente est disponible. Nous vous recommandons de la mettre à jour pour une meilleure performance.",
    "valid until": "Valable jusqu'au",
    "version details after connection is established": "Les détails de la version s'afficheront ici après la première connexion à partir de la carte entreprise."
  },
  "Cookies": {
    "accept": "Accepter",
    "always active": "Toujours actif",
    "analytics cookies": "Cookies d'analyse",
    "analytics cookies description": "Ces traceurs sont utilisés à des fins d'analyse et permettent de collecter des données qui nous aident à comprendre comment les utilisateurs interagissent avec nos sites web. Ces informations nous permettent à la fois d'améliorer le contenu et de développer de meilleures fonctionnalités qui améliorent l'expérience utilisateur. Cette catégorie de cookies peut être désactivée.",
    "cookie banner message": "Nous et certains tiers utilisons des cookies ou des technologies similaires à des fins techniques et, avec votre consentement, à d'autres fins telles que spécifiées dans la <1>politique en matière </1>de cookies.",
    "cookie modal title": "Nous utilisons des cookies",
    "cookie policy": "politique en matière de cookies",
    "essential cookies": "Cookies essentiels",
    "essential cookies description": "Ces traceurs sont utilisés pour des activités strictement nécessaires au fonctionnement ou à la mise à disposition du service que vous nous avez demandé. Ces cookies ne collectent pas d'informations vous concernant qui pourraient être utilisées à des fins de marketing et ne mémorisent pas les sites que vous avez consultés sur Internet. Cette catégorie de cookies ne peut pas être désactivée.",
    "text": "Ce site web stocke des données telles que des cookies afin d'assurer les fonctionnalités nécessaires du site, y compris l'analyse de données."
  },
  "Dashboard": {
    "added": "Ajouté",
    "Available": "Disponible",
    "cards": "Cartes",
    "card tooltips": {
      "connectivity": "<strong>En ligne :</strong>\nL'appareil s'est connecté au cours des dernières 24 heures\n\n<strong>Hors ligne :</strong>\nL'appareil ne s'est pas connecté au cours des dernières 24 heures\n\n<strong>Inactif :</strong>\nL'appareil n'a jamais établi de connexion réussie avec TachoSync",
      "driver downloads": "<strong>À l'heure :</strong>\n0 à 14 jours depuis le dernier téléchargement\n\n<strong>À venir :</strong>\n15 à 28 jours depuis le dernier téléchargement\n\n<strong>En retard :</strong>\n29 jours ou plus depuis le dernier téléchargement\n\n<strong>Aucun téléchargement :</strong>\nAucun téléchargement n'a encore été effectué",
      "vehicle downloads": "<strong>À l'heure :</strong>\n0 à 60 jours depuis le dernier téléchargement\n\n<strong>À venir :</strong>\n61 à 90 jours depuis le dernier téléchargement\n\n<strong>En retard :</strong>\n91 jours ou plus depuis le dernier téléchargement\n\n<strong>Aucun téléchargement :</strong>\nAucun téléchargement n'a encore été effectué"
    },
    "cc expiry": {
      "expired": "Expiré",
      "near expiry": "Expiration imminente",
      "near expiry tooltip": "Expiration dans les 3 mois",
      "upcoming expiry": "Prochaine expiration ",
      "upcoming expiry tooltip": "Expiration dans 3 à 6 mois"
    },
    "company cards": "Cartes entreprise",
    "company cards expiration": "Expiration des cartes entreprise",
    "connectivity": "Connectivité",
    "connectivity tabs": {
      "company cards": "Cartes entreprise",
      "devices": "Appareils"
    },
    "credit overdraft activated": "La fonction de découvert vous permet d'utiliser jusqu'à {{overDraftAmount}} crédits au-delà de votre solde.",
    "credits": "Crédits",
    "credits health": {
      "Healthy": "En bonne santé",
      "InOverdraft": "À découvert",
      "LimitReached": "Limite atteinte",
      "LowCredits": "Faible nombre de crédits",
      "OverdraftLimitReached": "Limite atteinte"
    },
    "credits history": "Historique des crédits",
    "credits history actions": {
      "BonusCredits": "Crédits bonus",
      "CreditsExpiration": "Expiration des crédits",
      "Deduction": "Prélèvement mensuel",
      "FreeTrial": "Ajout de crédits de démonstration",
      "MonthlyDeduction": "Prélèvement mensuel",
      "Purchase": "Crédits ajoutés",
      "WebTachoLicenseConversion": "Migration"
    },
    "credits statuses": {
      "available": "Disponible",
      "balance": "Solde",
      "overdraft": "Découvert bancaire",
      "remaining overdraft": "Fennmaradó folyószámlahitel",
      "reserved": "Réservé"
    },
    "Deactivated": "Désactivé",
    "deducted": "Déduit",
    "demo credits": {
      "demo": "Démonstration",
      "demo credits expired tooltip": "Les crédits de démonstration ont expiré. Veuillez acheter des crédits pour continuer à utiliser TachoSync.",
      "demo credits used up tooltip": "Tous les crédits de démonstration ont été utilisés. Veuillez acheter des crédits pour continuer à utiliser TachoSync.",
      "demo info tooltip": "Les crédits de démonstration sont activés lors de la première connexion IMEI et restent valables pendant 90 jours."
    },
    "device status": "État de l'appareil",
    "devices": "Appareils",
    "driver data": "Données des conducteurs",
    "driver downloads": "Téléchargements par le conducteur",
    "DueSoon": "À venir",
    "estimated": "Estimation",
    "expires": "Expiration",
    "how credits work": {
      "bottom content": {
        "header": "Quand un crédit est-il réservé ?",
        "table": {
          "body": {
            "any": "N'importe lequel",
            "any behaviour": "Pas de nouveau crédit. La réservation existante reste valable jusqu'à la fin du mois.",
            "newly assigned": "Nouvellement affecté",
            "newly assigned behaviour": "Réservé lors de la connexion. Migré vers VIN après le premier téléchargement.",
            "replaced vin known": "Remplacé (numéro d'identification du véhicule connu)",
            "replaced vin known behaviour": "Pas de nouveau crédit. La réservation existante reste valable.",
            "none": "Aucun",
            "none behaviour": "Aucun crédit n'est réservé. Les téléchargements ne commenceront pas tant qu'un appareil n'aura pas été attribué."
          },
          "head": {
            "credit behaviour": "Comportement de paiement",
            "device": "Appareil",
            "vehicle status": "État du véhicule"
          }
        }
      },
      "button tooltip": "Découvrez le fonctionnement des crédits",
      "main description": "Les crédits TachoSync sont valables 12 mois. Chaque nouvel achat prolonge la date d'expiration de 12 mois supplémentaires, ce qui vous garantit de pouvoir continuer à utiliser vos crédits tant que vous restez actif.",
      "main title": "Fonctionnement des crédits",
      "middle content": {
        "description": "L'utilisation des crédits de votre flotte reflète exactement le nombre de véhicules actifs, sur la base de leur numéro d'identification unique (VIN). Les appareils peuvent être remplacés, déplacés d'un véhicule à l'autre ou réaffectés à d'autres filiales sans consommer de crédit supplémentaire, à condition que l'identité du véhicule soit déjà établie.",
        "header": "Les crédits sont attribués par véhicule actif, et non par appareil.",
        "read more on wiki": "En savoir plus sur le Wiki"
      },
      "top content": {
        "active vehicle": "Véhicule en service",
        "device can change freely": "L'appareil peut être changé librement",
        "equals one credit": "= 1 crédit",
        "identified by IMEI": "Identifiés par leur numéro IMEI",
        "identified by VIN": "Identification par numéro d'identification du véhicule (VIN)",
        "tracking device": "Dispositif de suivi"
      }
    },
    "Inactive": "Inactif",
    "last 12 months": "12 derniers mois",
    "news": "Actualités",
    "no history to show": "Aucun historique à afficher",
    "no news": "Aucune actualité à afficher",
    "no results": "Aucun résultat",
    "NoDownloads": "Aucun téléchargement",
    "Offline": "Hors ligne",
    "Online": "En ligne",
    "OnTime": "À l'heure",
    "Overdue": "En retard",
    "Remaining": "Reste",
    "Reserved": "Réservé",
    "response error": "Une erreur s'est produite. Veuillez actualiser la page",
    "timeline": "Chronologie",
    "tooltip": {
      "click to expand": "Cliquez pour développer",
      "connected card expire soon": "La carte expirera bientôt : {{expirationDate}}",
      "disconnected card": "La carte d'entreprise est déconnectée.\nDernière connexion : {{lastSeen}}.",
      "disconnected card expire soon": "La carte d'entreprise est déconnectée.\nDernière connexion : {{lastSeen}}. \n \n La carte expirera bientôt : {{expirationDate}}.",
      "expired card": "La carte a expiré le {{expirationDate}}.\nRemplacez la carte d'entreprise par une carte valide.",
      "offline card": "La carte d'entreprise est hors ligne.\nDernière connexion : {{lastSeen}}.",
      "take me there": "Accéder à cette page"
    },
    "Upcoming charge": "Frais à venir",
    "vehicle data": "Données des véhicules",
    "vehicle downloads": "Téléchargements de données de véhicules",
    "view history": "Afficher l'historique"
  },
  "Date picker": {
    "disableFuture": "Date de désactivation",
    "disablePast": "Date de désactivation",
    "invalid date format": "Format de date non valide",
    "invalidDate": "Date non valide",
    "maxDate": "Date incorrecte",
    "minDate": "Date incorrecte",
    "shouldDisableDate": "Date de désactivation"
  },
  "Details": {
    "activities": "Activités",
    "add new email recipient": {
      "choose a file format": "Choisissez un format de fichier",
      "enter email": "Entrez votre adresse e-mail",
      "title": "Ajouter un nouveau destinataire"
    },
    "api company id": "API Identifiant de l'entreprise",
    "autoAssignGlobalScheduleToDriver": "Attribuer un planning global aux nouveaux conducteurs",
    "autoAssignGlobalScheduleToVehicle": "Attribuer un calendrier global aux nouveaux véhicules",
    "automaticDriverRegistrationEnabled": "Enregistrement automatique des nouveaux conducteurs",
    "card holder": "Nom du titulaire de la carte",
    "client code": "Code client",
    "close details": "Masquer les détails",
    "company": "Entreprise",
    "company cards": "Cartes d'entreprise",
    "company cards limit reached": "Vous avez atteint le nombre maximal de cartes d'entreprise pour cette société, {{currCount}}/{{maxCount}}.",
    "company settings": "Paramètres de l'entreprise",
    "Completed": "Terminé",
    "connection settings": "Paramètres de connexion",
    "creator": "Créateur",
    "credits": "Crédits",
    "credits overdraft tooltip": "La logique de réservation mensuelle de crédit a été mise à jour pour autoriser un solde négatif sur le compte. Cela permettra une transition plus en douceur depuis Web Tacho sans pression sur les achats immédiats de crédit.",
    "current status": "Situation actuelle",
    "Daily": "Quotidien",
    "data types": "Types de données",
    "deactivated": "Désactivé",
    "deactivated vehicle banner": {
      "description": "Ce véhicule ne pourra pas accumuler de nouveaux crédits et les fichiers du véhicule ne pourront pas être téléchargés tant qu'il n'aura pas été activé.",
      "link": "Activer le véhicule",
      "title": "Le véhicule est désactivé"
    },
    "detailed speed": "Vitesse détaillée",
    "details": "Détails",
    "device imei": "IMEI de l'appareil",
    "device status": "État de l'appareil",
    "download status": "État du téléchargement",
    "download time": "Durée du téléchargement",
    "DownloadPending": "Téléchargement en attente",
    "driver": "Conducteur",
    "driver id": "Identifiant du conducteur",
    "driver status": "Statut du conducteur",
    "drivers": "Conducteurs",
    "edit": "Modifier",
    "edit user": "Modifier {{userEmail}}",
    "email limit reached": "Vous avez atteint le nombre maximal d'e-mails pour cette entreprise.",
    "email transfer": "Transfert par e-mail",
    "email transfer info tooltip": "La fonctionnalité de transfert par e-mail vous permet de recevoir les données de tachygraphe téléchargées par e-mail. Une fois le cycle terminé, le système transmet automatiquement l'e-mail aux destinataires configurés. Chaque entreprise peut ajouter jusqu'à {{maxCount}} destinataires.",
    "endpointUrl": "URL de la page de destination",
    "events and faults": "Événements et défauts",
    "Every  days": "Tous les {{count}} jours",
    "Every month": "Chaque mois",
    "EveryDays": "Tous les {{count}} jours",
    "Feature not available in BETA version": "Fonctionnalité non disponible dans la version BETA",
    "file format": "Format de fichier",
    "file sync": "Synchronisation de fichiers",
    "general": "Général",
    "host": "Hébergeur",
    "imei": "IMEI",
    "included": "Inclus",
    "integration method": {
      "Ftps": "FTPS",
      "Sftp": "SFTP",
      "Webhook": "Webhook"
    },
    "last activity": "Dernière activité",
    "last download attempt": "Dernière tentative de téléchargement",
    "last successful download": "Dernier téléchargement réussi",
    "Never": "Jamais",
    "next download": "Téléchargement suivant",
    "next download attempt": "Prochaine tentative de téléchargement",
    "Next download attempt in  day": "Prochaine tentative de téléchargement dans {{count}} jours",
    "Next download attempt in  days": "Prochaine tentative de téléchargement dans {{count}} jours",
    "no company cards": "Aucune carte d'entreprise ajoutée.",
    "no driver schedule": "Aucun horaire n'est attribué au conducteur.",
    "no recipients added": "Aucun destinataire ajouté",
    "no vehicle schedule": "Aucun horaire n'est appliqué au véhicule.",
    "not included": "Non inclus",
    "on next connection": "Lors de la prochaine connexion",
    "open files": "Ouvrir les fichiers",
    "open files disabled tooltip": "Cet objet ne contient aucun fichier.",
    "other": "Autres",
    "overview": "Aperçu",
    "parent company": "Société mère",
    "password": "Mot de passe",
    "port": "Port",
    "Quick schedule was completed": "Le calendrier rapide a été finalisé",
    "remotePath": "Chemin d'accès au répertoire distant",
    "remove": "Supprimer",
    "remove email recipient": {
      "description": "Êtes-vous sûr de vouloir supprimer ce destinataire ? Cette action est irréversible.",
      "title": "Supprimer {{userEmail}} ?"
    },
    "remove schedule": "Supprimer le calendrier",
    "reserved": "Réservé",
    "schedule details": "Détails du calendrier",
    "schedule history": "Historique des horaires",
    "schedule start time": "Heure de début du planning",
    "schedules": "Horaires",
    "show less": "Afficher moins",
    "show more": "Afficher plus",
    "show older": "Afficher les plus anciens",
    "status": "Statut",
    "sub companies": "Filiales",
    "technical data": "Caractéristiques techniques",
    "Upon device connection": "Connexion sur l'appareil",
    "username": "Nom d'utilisateur",
    "users": "Utilisateurs",
    "vehicles": "Véhicules",
    "vrn": "VRN",
    "WaitingForDeviceConnection": "En attente de connexion de l'appareil",
    "WaitingForScheduleStartTime": "En attente de l'heure de début du planning"
  },
  "Dialog": {
    "account id": "Identifiant de compte",
    "account id cannot contain more than": "L'identifiant de compte ne peut pas contenir plus de {{maxNumber}} caractères",
    "activate vehicles": {
      "description": "Une fois activés, les véhicules pourront utiliser des crédits en fonction d'une connexion mensuelle unique. Êtes-vous sûr de vouloir activer le nombre de véhicules suivant ?",
      "title": "Activer les véhicules ?"
    },
    "add": "Ajouter",
    "add company card": "Ajouter une nouvelle fiche d'entreprise",
    "add driver": "Ajouter un conducteur",
    "add integration": "Ajouter une intégration",
    "add new integration": {
      "description": "Choisissez le type d'intégration à ajouter, puis configurez les détails à l'étape suivante.",
      "title": "Ajouter une nouvelle intégration"
    },
    "add vehicle": "Ajouter un véhicule",
    "add vehicle description": "Ajoutez un véhicule en saisissant manuellement toutes les informations d'immatriculation.",
    "add vehicle imei in use accessible": {
      "description": "Cet IMEI est déjà associé à un autre véhicule. Sa réattribution déconnectera ce véhicule des téléchargements de fichiers. Voulez-vous vraiment continuer ?",
      "title": "IMEI déjà utilisé",
      "vehicle imei": "Véhicule utilisant l'IMEI « {{imeiValue}} » :"
    },
    "all resource": "Toutes les {{resource}}",
    "api key": "Clé API",
    "api key placeholder": "Saisir la clé API",
    "api key cannot contain more than": "La clé API ne doit pas contenir plus de {{maxNumber}} caractères",
    "api key edit": {
      "dialog title": "Modifier la clé API « {{keyName}} »",
      "success banner": "API key a été modifié avec succès."
    },
    "api key name": "Nom de la clé",
    "api key name required": "Le nom de la clé ne peut pas être vide",
    "api key name too long": "Le nom de la clé ne peut pas dépasser {{maxNumber}} caractères",
    "api management": {
      "description": "Créez votre clé API pour gérer en toute sécurité l'accès API à notre système, ce qui permet une intégration transparente avec vos propres logiciels et flux de travail. La documentation de l'API TachoSync est disponible ",
      "generated api key": "Clé API générée",
      "success banner": "La clé API a été créée avec succès. Veuillez enregistrer les informations ci-dessous, car vous ne pourrez plus les consulter ultérieurement."
    },
    "cancel invitation": "Annuler l'invitation",
    "cancel invitation description": "Êtes-vous sûr de vouloir annuler l'invitation de {{userEmail}} ?",
    "card holder name": "Nom du titulaire de la carte",
    "card holder name not valid": "Le nom du titulaire de la carte ne peut pas contenir plus de {{maxNumber}} caractères",
    "card holder name should not be empty": "Le nom du titulaire de la carte ne doit pas être vide",
    "card holder name too short": "Le nom du titulaire de la carte doit comporter au moins {{minNumber}} caractères",
    "card id not valid": "L'identifiant de la carte ne peut pas contenir plus de {{maxNumber}} caractères",
    "card id should contain only digits, letters and hyphens": "L'identifiant de la carte ne doit contenir que des chiffres (0 à 9), des lettres A à F et des tirets (-).",
    "card id should contain only numbers": "L'identifiant de la carte ne doit contenir que des chiffres",
    "card id should not be empty": "L'identifiant de la carte ne doit pas être vide",
    "card id too short": "L'identifiant de la carte doit comporter au moins {{minNumber}} caractères",
    "card name": "Nom de la carte",
    "card name not valid": "Le nom de la carte ne peut pas contenir plus de {{maxNumber}} caractères",
    "card name should not be empty": "Le nom de la carte ne doit pas être vide",
    "card name too short": "Le nom de la carte doit comporter au moins {{minNumber}} caractères",
    "choose period": "Choisissez une période",
    "client company": "Entreprise cliente",
    "company": "Entreprise",
    "company card id": "Identifiant de la carte d'entreprise",
    "company name": "Nom de l'entreprise",
    "company name in tachoSync": "Nom de l'entreprise dans TachoSync",
    "company name placeholder": "Ex. : Teltonika Telematics",
    "company settings": {
      "allow credits overdraft": "Autoriser le découvert",
      "auto add new drivers": "Enregistrement automatique des nouveaux conducteurs",
      "auto add new drivers tooltip": "Dès qu'un nouvel identifiant de conducteur est reconnu, TachoSync l'ajoute automatiquement au tableau des conducteurs.",
      "auto assign global schedule to drivers": "Attribuer automatiquement le calendrier global aux nouveaux conducteurs",
      "auto assign global schedule to drivers tooltip": "Applique automatiquement un calendrier de téléchargement global aux conducteurs nouvellement enregistrés, garantissant ainsi le téléchargement des données sans intervention manuelle.",
      "auto assign global schedule to vehicles": "Attribuer automatiquement le calendrier global aux nouveaux véhicules",
      "auto assign global schedule to vehicles tooltip": "Applique automatiquement un calendrier de téléchargement global aux véhicules nouvellement enregistrés, garantissant ainsi le téléchargement des données sans intervention manuelle.",
      "auto download driver data": "Téléchargement automatique des données du conducteur lors de la première connexion",
      "auto download driver data tooltip": "Télécharge automatiquement les données de la carte de conducteur dès la première connexion de ce dernier. Cela permet de saisir l'historique complet des nouveaux conducteurs avant de définir leurs plannings.",
      "auto update vehicle registration number": "Mise à jour automatique du numéro d'immatriculation du véhicule (VRN)",
      "auto update vehicle registration number tooltip": "Lorsque cette option est activée, le numéro d'immatriculation (VRN) saisi lors de la création du véhicule est remplacé par la valeur lue à partir des données du tachygraphe après le premier téléchargement réussi.",
      "automatic initial vehicle download": "Téléchargement automatique des données du véhicule lors de la première connexion",
      "automatic initial vehicle download tooltip": "Télécharge automatiquement les données du véhicule dès sa première connexion. Cela permet de capturer l'historique complet des nouveaux véhicules avant de configurer les plannings.",
      "title": "Paramètres de l'entreprise"
    },
    "confirm add schedule": "Ajouter un calendrier ?",
    "confirm deactivate api key": {
      "description": "Êtes-vous sûr de vouloir désactiver la clé API « {{apiKeyName}} » ?",
      "title": "Désactiver la clé API ?"
    },
    "confirm deactivate integration": {
      "description": "Êtes-vous sûr de vouloir désactiver l'intégration « {{integrationName}} » ?",
      "title": "Désactiver l'intégration ?"
    },
    "confirm delete analysis providers": "Êtes-vous sûr de vouloir supprimer le nombre suivant de fournisseurs d'analyses ? Cette action est irréversible.",
    "confirm delete api credentials": "Êtes-vous sûr de vouloir supprimer les identifiants API sélectionnés ? Cette action est irréversible, et tout appel API effectué avec ces identifiants sera immédiatement rejeté.",
    "confirm delete companies": "Êtes-vous sûr de vouloir supprimer l'entreprise sélectionnée ? Cette action est irréversible.",
    "confirm delete drivers": "Cette opération supprimera toutes les données des conducteurs, mais les fichiers des conducteurs seront conservés. Êtes-vous sûr de vouloir supprimer le nombre de conducteurs suivant ?",
    "confirm delete integrations": "Êtes-vous sûr de vouloir supprimer le nombre d'intégrations suivant ? Cette action est irréversible.",
    "confirm delete users": "Êtes-vous sûr de vouloir supprimer le nombre d'utilisateurs suivant ? Cette action est irréversible.",
    "confirm delete vehicles": "Cette opération supprimera toutes les données des véhicules, mais les fichiers des véhicules seront conservés. Êtes-vous sûr de vouloir supprimer le nombre de véhicules suivant ?",
    "confirm empty imei": {
      "description": "Vous n'avez pas renseigné le champ IMEI. Les véhicules sans IMEI ne peuvent pas se connecter à TachoSync et ne peuvent pas télécharger de fichiers.\nVoulez-vous vraiment continuer ?",
      "title": "Aucun IMEI ajouté"
    },
    "convey integration": {
      "add": {
        "description": "Configurez votre connexion Convey",
        "title": "Ajouter l'intégration Convey"
      },
      "edit": {
        "description": "Configurez votre connexion Convey",
        "title": "Modifier l'intégration Convey"
      },
      "provider settings description": "Veillez à utiliser les identifiants fournis par Convey.",
      "provider settings title": "Paramètres du fournisseur"
    },
    "create": "Créer",
    "create company": "Créer une entreprise",
    "create company main description": "Choisissez de créer une nouvelle filiale au sein de cette hiérarchie ou de créer un nouveau client à l'aide d'un code LZ client.",
    "create new hierarchy": "Créer une nouvelle hiérarchie",
    "create news": "Créer une actualité",
    "create news description": "Présentez brièvement le contenu de la fenêtre contextuelle.",
    "create quick schedule": "Créer un planning rapide",
    "create schedule": "Créer un planning",
    "create schedule description": "Configurez le téléchargement automatique de fichiers en sélectionnant une date, une heure et une fréquence. Le système se chargera des téléchargements à votre place, garantissant ainsi la conformité et l'exactitude des données sans intervention manuelle. L'heure de début ne peut pas être définie dans le passé.",
    "credits history": {
      "description": "Suivez votre solde de crédits actuel et consultez l'historique des données.",
      "description generate report": "Suivez votre solde de crédits actuel, consultez l'historique et générez un rapport au format « .csv » répertoriant tous les crédits utilisés au cours des 12 derniers mois.",
      "generate report description": "Choisissez n'importe quelle période au cours des 12 derniers mois et générez un rapport sur les crédits consommés.",
      "generate report title": "Générer un rapport",
      "title": "Historique des crédits"
    },
    "custom period": "Période personnalisée",
    "date display format": "Format d'affichage de la date",
    "date range": "Période",
    "deactivate vehicle": "Désactiver ce véhicule",
    "deactivate vehicle description": "Les véhicules désactivés ne pourront pas accumuler de nouveaux crédits et ne pourront plus télécharger de données",
    "deactivate vehicles": {
      "description": "Les véhicules désactivés ne pourront pas accumuler de nouveaux crédits et ne pourront plus télécharger de données.",
      "title": "Désactiver des véhicules ?"
    },
    "delete": "Supprimer",
    "delete analysis providers": "Supprimer les fournisseurs d'analyses ?",
    "delete api credentials": "Supprimer les identifiants API ?",
    "delete companies": "Supprimer des entreprises ?",
    "delete companies warning": "La suppression d'entreprises entraînera la suppression de toutes les ressources appartenant à ces entreprises.",
    "delete drivers": "Supprimer des conducteurs ?",
    "delete integrations": "Supprimer les intégrations ?",
    "delete news": "Supprimer l'actualité ?",
    "delete news description": "Êtes-vous sûr de vouloir supprimer les actualités sélectionnées ?",
    "delete unpublished release notes": "Supprimer les notes de mise à jour non publiées ?",
    "delete unpublished release notes description": "Êtes-vous sûr de vouloir supprimer les notes de mise à jour non publiées ?",
    "delete users": "Supprimer des utilisateurs ?",
    "delete vehicles": "Supprimer des véhicules ?",
    "description": "Description (facultatif)",
    "description not valid": "La description ne peut pas contenir plus de {{maxNumber}} caractères",
    "description required": "Description",
    "description should not be empty": "La description ne doit pas être vide",
    "device imei": "IMEI de l'appareil",
    "dialog description": {
      "create company description": "Le nombre maximal de niveaux autorisé dans l'arborescence d'une entreprise est {{maxNumber}}.",
      "create new hierarchy description": "Le nombre maximal de niveaux autorisé dans l'arborescence d'une entreprise est {{maxNumber}}. Choisissez de créer une nouvelle filiale au sein de cette hiérarchie ou de créer un nouveau client à l'aide d'un code LZ client."
    },
    "download activities": "Activités de téléchargement",
    "download blocked message": "Téléchargement bloqué - contactez votre fournisseur d'accès pour résoudre le problème.",
    "download data types": "Types de données à télécharger",
    "download drivers files": "Télécharger les fichiers des pilotes",
    "download history dialog title": "Historique du {{vehicleNumber}}",
    "download monitoring dialog tooltip": "Toutes les données de cette vue sont automatiquement actualisées toutes <strong>les 10 secondes</strong>.\nL'état de l'appareil correspond à la dernière connexion et non à l'état actuel du véhicule.",
    "download only selection": "Seuls les fichiers sélectionnés seront téléchargés.",
    "download sample file message": "Téléchargez un <1>modèle de fichier CSV</1> pour voir un exemple du format requis.",
    "download status banners": {
      "CompanyCardExpired": "La carte d'entreprise a expiré. Veuillez ajouter une carte d'entreprise valide.",
      "InsufficientCredits": "Crédits insuffisants. Veuillez ajouter des crédits pour pouvoir télécharger des fichiers.",
      "NoCompanyCards": "Une carte d'entreprise doit être connectée pour pouvoir commencer le téléchargement. Aucune n'est disponible pour le moment.",
      "NoSchedulesApplied": "Aucun horaire n'est appliqué à ce véhicule.",
      "VehicleDeactivated": "Ce véhicule est désactivé et ne peut pas lancer le processus de téléchargement."
    },
    "download status dialog title": "Suivi des téléchargements de {{vehicleNumber}}",
    "download vehicles files": "Télécharger les fichiers des véhicules",
    "driver file destination": "Destination des fichiers conducteur",
    "driver file destination tooltip": "Choisissez si les fichiers des conducteurs doivent être enregistrés dans le dossier du véhicule à partir duquel ils ont été téléchargés ou dans des dossiers dédiés par identifiant de conducteur.",
    "driver folder": "Dossier du conducteur",
    "driver id": "Identifiant du conducteur",
    "driver id not valid": "L'identifiant du conducteur doit comporter {{maxNumber}} caractères alphanumériques",
    "driver id placeholder": "Ex. : 360896050032309",
    "driver id should not be empty": "Le champ « Identifiant du conducteur » ne doit pas être vide",
    "driver name": "Nom du conducteur",
    "drivers folder naming": "Nommer les dossiers des conducteurs",
    "edit company": "Modifier l'entreprise « {{name}} »",
    "edit driver": "Modifier le conducteur « {{name}} »",
    "edit news": "Modifier l'actualité",
    "edit release notes tooltip": "Ces actualités sont créées sous forme de notes de mise à jour et ne peuvent pas être modifiées.",
    "edit user": "Modifier l'utilisateur",
    "edit vehicle": "Modifier le véhicule « {{name}} »",
    "edit vehicle imei in use accessible": {
      "description": "Cet IMEI est déjà attribué à un autre véhicule. Vous pouvez choisir d'échanger les IMEI entre les deux véhicules ou de remplacer l'IMEI.",
      "title": "IMEI déjà utilisé"
    },
    "email": "E-mail",
    "endpointUrl": "URL de la page de destination",
    "endpoint url": "URL de la page de destination",
    "endpoint url not valid": "L'URL de destination n'est pas valide",
    "endpoint url placeholder": "Saisir l'URL",
    "enter": "Entrer",
    "enter company card id": "Veuillez saisir l'identifiant de la carte d'entreprise qui se trouve dans l'application Company Card Authenticator.",
    "enter here": "Entrez ici",
    "enter name": "Entrez un nom",
    "enter password": "Saisir le mot de passe",
    "enter username": "Entrez votre nom d'utilisateur",
    "expiration date optional": "Date d'expiration (facultatif)",
    "export drivers": {
      "description": "Exportez tous les conducteurs de l’entreprise sélectionnée vers les fichiers .csv requis.",
      "include drivers from all companies": "Inclure les conducteurs de toutes les entreprises",
      "title": "Exporter les données des conducteurs"
    },
    "export vehicles": {
      "description": "Exportez tous les véhicules de l’entreprise sélectionnée vers les fichiers .csv requis.",
      "include vehicles from all companies": "Inclure les véhicules de toutes les entreprises",
      "title": "Exporter les véhicules"
    },
    "feature switches": {
      "feature switches": "Commutateurs de fonctionnalités",
      "toggle integrations page": "Page « Activer les intégrations »"
    },
    "field cannot be changed": "Ce champ ne peut pas être modifié",
    "field cannot be empty": "{{fieldName}} ne peut pas être vide",
    "field length not valid": "Ce champ ne peut pas contenir plus de {{maxNumber}} caractères",
    "file format": "Format de fichier",
    "filtered resource": "Filtré {{resource}}",
    "filtered drivers": "Conducteurs filtrés",
    "filtered vehicles": "Véhicules filtrés",
    "from": "De",
    "future dates": {
      "1 day": "dans 1 jour",
      "1 minute": "dans 1 minute",
      "1 month": "dans 1 mois",
      "1 week": "dans 1 semaine",
      "1 year": "dans 1 an",
      "hours and minutes": "dans {{hourCount}} h {{minutesCount}} min",
      "less than a minute": "en <1 minute",
      "multiple days": "dans {{daysCount}} jours",
      "multiple minutes": "dans {{minutesCount}} minutes",
      "multiple months": "dans {{monthsCount}} mois",
      "multiple weeks": "dans {{weeksCount}} semaines",
      "multiple years": "dans {{yearsCount}} ans"
    },
    "generate api key": {
      "title": "Générer une clé API"
    },
    "host": "Hébergeur",
    "host cannot contain more than": "Le champ ne peut pas contenir plus de {{maxNumber}} caractères",
    "imei": "IMEI",
    "imei not valid": "L'IMEI doit comporter {{maxNumber}} caractères numériques",
    "imei placeholder": "Ex. : 360896050032309",
    "imei should not be empty": "Le champ IMEI ne doit pas être vide",
    "import drivers": "Importer des conducteurs",
    "import drivers description": "Ajoutez des conducteurs à votre liste en les important depuis un fichier.",
    "import vehicles": "Importation de véhicules",
    "import vehicles description": "Ajoutez des véhicules à votre liste en les important depuis un fichier.",
    "integration name": "Nom de l'intégration",
    "integration type": "Type d'intégration",
    "integrations": {
      "deactivate integration": {
        "title": "Désactiver cette intégration",
        "tooltip": "Désactivez temporairement l'intégration. Vous pouvez la réactiver en décochant cette option."
      },
      "deactivate api key": "Désactiver la clé API",
      "deactivate sftp": "Désactiver le SFTP",
      "deactivate integration tooltip": "Désactivez temporairement l'intégration. Vous pouvez la réactiver en décochant cette option.",
      "disable integration": {
        "description": "Êtes-vous sûr de vouloir désactiver l'intégration « {{integrationName}} » ?",
        "title": "Désactiver l'intégration ?"
      },
      "driver files info banner": "Veuillez noter que les fichiers des conducteurs téléchargés avant le {{formattedDate}} seront placés dans le dossier du véhicule le plus récemment conduit par le conducteur. ",
      "errors": {
        "AuthenticationFailed": {
          "description": "Veuillez vous assurer que votre nom d'utilisateur et votre mot de passe sont correctement saisis.\nL'intégration sera enregistrée avec le statut « Échec » jusqu'à ce que les identifiants corrects soient saisis.",
          "title": "Identifiants incorrects."
        },
        "FolderCreationFailed": {
          "description": "TachoSync est connecté au serveur, mais ne dispose pas des autorisations nécessaires pour créer des dossiers ou télécharger des fichiers vers le chemin de destination.\nL'intégration sera enregistrée avec le statut « Échec » jusqu'à ce que le problème soit résolu et que vous réessayiez de vous connecter.",
          "title": "Accès en écriture manquant."
        },
        "HostUnreachable": {
          "description": "Veuillez vous assurer que l'adresse et le port du serveur sont corrects et que le serveur est en ligne.\nL'intégration sera enregistrée avec le statut « Échec » jusqu'à ce que le problème soit résolu et que vous réessayiez de vous connecter.",
          "title": "L'hôte est inaccessible"
        },
        "PathNotFound": {
          "description": "Le répertoire spécifié est introuvable sur le serveur. Veuillez vérifier que le chemin d'accès est correct.\nL'intégration sera enregistrée avec le statut « Échec » jusqu'à ce qu'un chemin d'accès correct soit fourni.",
          "title": "Chemin d'accès introuvable."
        },
        "PermissionDenied": {
          "description": "Veuillez vous assurer que TachoSync dispose des autorisations nécessaires pour accéder à ce chemin d'accès.\nL'intégration sera enregistrée avec le statut « Échec » jusqu'à ce que les autorisations soient mises à jour et que vous réessayiez de vous connecter.",
          "title": "Accès au chemin refusé."
        },
        "Unknown": {
          "description": "Un problème inattendu s'est produit lors de la tentative de connexion au serveur SFTP. Veuillez vérifier les informations et les paramètres de votre serveur.\nL'intégration sera enregistrée avec le statut « Échec » jusqu'à ce que le problème soit résolu et que vous réessayiez de vous connecter.",
          "title": "Erreur inattendue s`est produit"
        }
      },
      "include files from all sub companies": "Inclure les fichiers de toutes les filiales",
      "include files tooltip": "Une fois sélectionnée, cette intégration récupérera également les fichiers de toutes les filiales associées à votre compte",
      "include historical files": "Inclure les fichiers historiques",
      "include historical files tooltip": "Une fois sélectionné, les fichiers téléchargés avant la création de cette intégration seront également récupérés",
      "select driver files destination": "Sélectionner la destination des fichiers du conducteur"
    },
    "introduce name": "Saisir le nom",
    "invite user": "Inviter un utilisateur",
    "invite user description": "Une fois l'invitation envoyée, l'utilisateur recevra un \ne-mail contenant un lien pour créer un compte. Ce lien sera valable pendant 7 jours.",
    "invite user sent": "Invitation de l'utilisateur envoyée avec succès.",
    "loading": "Chargement en cours...",
    "make release notes": "Rédiger les notes de version / Créer les notes de mise à jour",
    "make release notes info": "Si ce champ est coché, l'actualité sera publiée dans les Notes de mise à jour, et le titre sera remplacé par Notes de mise à jour.",
    "max download files": "Nombre maximal de fichiers autorisé par opération de téléchargement : {{maxNumber}}.",
    "move company": {
      "confirmation dialog": {
        "are you sure": "Êtes-vous sûr ?",
        "description": "Vous êtes sur le point de transférer « {{sourceCompany}} » vers « {{targetCompany}} ». Cette action est irréversible, êtes-vous sûr de vouloir continuer ?"
      },
      "description": "Sélectionnez une entreprise source et une entreprise cible vers laquelle la transférer. L'entreprise source et ses ressources seront placées sous l'entreprise cible sélectionnée. Cette action est irréversible.",
      "error dialog": {
        "description": "Le nombre maximal de niveaux d'entreprise autorisé est de 4. Le déplacement de l'entreprise sélectionnée vers cet emplacement dépasserait cette limite.",
        "title": "Impossible de déplacer l'entreprise"
      },
      "info banner": "La société d'origine conservera l'ensemble de ses véhicules, conducteurs, fichiers, entreprises, utilisateurs, intégrations et plannings personnalisés. Si un planning global est activé au niveau de la société mère, il sera repris après le transfert. Dans le cas contraire, les plannings existants seront conservés tels quels.",
      "source company": "Entreprise source",
      "sftp warning": "L'entreprise sélectionnée dispose d'un serveur SFTP opérationnel et configuré. La connexion SFTP sera interrompue pendant le transfert de l'entreprise. Une fois le transfert terminé, un nouveau chemin d'accès SFTP sera créé et la connexion sera rétablie.",
      "target company": "Entreprise cible",
      "title": "Déménagement d'entreprise"
    },
    "move vehicles": "Déplacer des véhicules",
    "move vehicles info": "Remarque : les fichiers des véhicules resteront dans l'entreprise actuelle. L'historique des téléchargements sera effacé et les calendriers de téléchargement seront supprimés.",
    "name": "Nom",
    "name not valid": "Le nom ne peut pas contenir plus de {{maxNumber}} caractères",
    "name should not be empty": "Le champ Nom ne doit pas être vide",
    "name too short": "Le nom doit comporter au moins {{minNumber}} caractères",
    "optional": "facultatif",
    "overwrite imei checkbox": {
      "description": "Cette option supprimera l'IMEI de {{vehicleNumber}}.",
      "title": "Remplacer l'IMEI."
    },
    "parent company": "Société mère",
    "password": "Mot de passe",
    "password cannot contain more than": "Le mot de passe ne peut pas contenir plus de {{maxNumber}} caractères",
    "past dates": {
      "1 month ago": "Il y a 1 mois",
      "1 week ago": "Il y a 1 semaine",
      "1 year ago": "Il y a 1 an",
      "multiple months ago": "Il y a {{monthCount}} mois",
      "multiple weeks ago": "Il y a {{weekCount}} semaines",
      "multiple years ago": "Il y a {{yearCount}} ans",
      "today": "Aujourd’hui",
      "yesterday": "Hier"
    },
    "port": "Port",
    "port must be between": "La valeur du port doit être supérieure à {{minNumber}} et inférieure à {{maxNumber}}",
    "previous month": "Mois précédent",
    "provider": "Fournisseur",
    "publish news": "Publier une actualité ?",
    "publish news description": "Cet article est sur le point d'être publié. Êtes-vous sûr de vouloir continuer ? Cette action est irréversible.",
    "publish release notes": "Publier les notes de mise à jour ?",
    "publish release notes description": "Les notes de mise à jour sont prêtes à être publiées. Voulez-vous vraiment continuer ? Cette action est irréversible.",
    "release notes": "Notes de mise à jour",
    "remote directory path cannot contain more than": "Le chemin d'accès au répertoire distant ne peut pas contenir plus de {{maxNumber}} caractères",
    "remote directory path optional": "Chemin d'accès au répertoire distant (facultatif)",
    "remove": "Supprimer",
    "remove schedules": "Supprimer les calendriers",
    "remove schedules confirmation description": {
      "drivers multiple": "Êtes-vous sûr de vouloir supprimer les calendriers {{resourceValue}} pour les conducteurs sélectionnés ?",
      "drivers single": "Êtes-vous sûr de vouloir supprimer {{resourceValue}} des conducteurs sélectionnés ?",
      "vehicles multiple": "Êtes-vous sûr de vouloir supprimer les planifications {{resourceValue}} des véhicules sélectionnés ?",
      "vehicles single": "Êtes-vous sûr de vouloir supprimer {{resourceValue}} des véhicules sélectionnés ?"
    },
    "remove schedules description": {
      "drivers": "Sélectionnez un ou plusieurs calendriers que vous souhaitez supprimer pour les conducteurs sélectionnés.",
      "vehicles": "Sélectionnez un ou plusieurs planifications que vous souhaitez supprimer des véhicules sélectionnés."
    },
    "resend invitation": "Renvoyer l'invitation",
    "resend invitation description": "Êtes-vous sûr de vouloir renvoyer l'invitation à {{userEmail}} ?",
    "role": "Rôle",
    "schedule apply to all": {
      "drivers": "L'horaire choisi s'appliquera à tous les conducteurs de l'entreprise sélectionnée.",
      "vehicles": "Le calendrier choisi s'appliquera à tous les véhicules de l'entreprise sélectionnée."
    },
    "schedule apply to filtered": {
      "drivers": "Le planning sélectionné sera appliqué aux conducteurs filtrés à l'aide d'un ou plusieurs filtres disponibles.",
      "vehicles": "Le planning sélectionné sera appliqué aux véhicules filtrés à l'aide d'un ou plusieurs filtres disponibles."
    },
    "schedule apply to selected": {
      "drivers": "Le planning sélectionné s’appliquera à tous les conducteurs cochés.",
      "vehicles": "Le calendrier choisi sera appliqué à tous les véhicules sélectionnés à l'aide de la case à cocher."
    },
    "schedule time tooltip description": "Si l'heure sélectionnée est antérieure à la date du jour, le système l'ajustera automatiquement à l'heure disponible la plus proche dans le futur.",
    "security settings": "Paramètres de sécurité",
    "security settings description": "Découvrez les options qui vous permettent de contrôler la protection de votre compte.",
    "select": "Sélectionner",
    "select a company": "Sélectionnez une entreprise",
    "select file format example": "Sélectionnez le format (par exemple .DDD)",
    "select format": "Sélectionner le format",
    "select image": "Sélectionner une image",
    "select image description": "Sélectionnez l'image que vous souhaitez utiliser en cliquant dessus, puis cliquez sur le bouton Enregistrer.",
    "select schedules": "Sélectionner les calendriers",
    "selected resource": "Sélectionner {{resource}}",
    "selected drivers": "Conducteurs sélectionnés",
    "selected vehicles": "Véhicules sélectionnés",
    "selected role info message": "<3>Cliquez ici</3> pour consulter le tableau détaillé des autorisations.",
    "selected role info message title": "Le rôle déterminera les autorisations des utilisateurs dans TachoSync.",
    "sftp integration": {
      "description": "Configurez votre connexion SFTP et définir la structure des fichiers du tachygraphe.",
      "edit title": "Modifier l'intégration SFTP « {{integrationName}} » ",
      "sftp name": "Nom SFTP",
      "title": "Intégration SFTP"
    },
    "sftp password": "Mot de passe SFTP",
    "sftp server hostname or ip": "Nom d'hôte ou adresse IP du serveur SFTP",
    "sftp server port number": "Numéro de port du serveur SFTP",
    "sftp server settings": "Paramètres du serveur SFTP",
    "sftp username": "Nom d'utilisateur SFTP",
    "Teltonika code": "Code de Teltonika ",
    "Teltonika code invalid characters": "Le code Teltonika doit supérieure à {{minCount}} et inférieure à {{maxCount}} caractères et peut inclure des lettres, des chiffres et des points. ",
    "Teltonika code placeholder": "Le code Teltonika doit comporter entre {{minCount}} et {{maxCount}} caractères",
    "Teltonika company name": "Nom de l'entreprise",
    "time": "Heure",
    "time zone": "Fuseau horaire",
    "title": "Titre",
    "title not valid": "Le titre ne peut pas dépasser {{maxNumber}} caractères",
    "title should not be empty": "Le titre ne doit pas être vide",
    "title too short": "Le titre doit contenir au moins {{minNumber}} caractères",
    "to": "À",
    "toggle children global schedule linking": "Connecté au calendrier global de la société mère.",
    "toggle children global schedule linking tooltip": "La société mère a activé l'héritage du calendrier global. Pour modifier le calendrier global de la société sélectionnée, désactivez cette option. Notez que cela déconnectera le calendrier global de la société mère.",
    "toggle global schedule linking": "Appliquer le calendrier global à toutes les filiales",
    "toggle global schedule linking tooltip": "L'activation de cette option applique le calendrier global à toutes les filiales. Les filiales peuvent désactiver cette option pour personnaliser leur propre calendrier global.",
    "toggle global schedule warning banner": "Certaines filiales peut-être utilisent déjà un calendrier global différent. Cette option ne les concernera pas, sauf si elles la sélectionnent dans leurs paramètres de calendrier global.",
    "unpublished release notes": "Il existe des notes de mise à jour non publiées.",
    "upload folder blank for root": "télécharger le dossier (vide pour la racine)",
    "username": "Nom d'utilisateur",
    "username cannot contain more than": "Le nom d'utilisateur ne peut pas dépasser {{maxNumber}} caractères",
    "vdo integration": {
      "add": {
        "description": "Configurez votre connexion de flotte VDO.",
        "title": "Ajouter l’intégration de flotte VDO"
      },
      "edit": {
        "description": "Configurez votre connexion de flotte VDO.",
        "title": "Modifier l'intégration de la flotte VDO"
      },
      "provider settings description": "Veillez à utiliser les identifiants fournis par VDO Fleet.",
      "provider settings title": "Paramètres du fournisseur"
    },
    "vehicle folder": "Dossier du véhicule",
    "vehicle imei in use inaccessible": {
      "description": "Cet IMEI est déjà attribué à une entreprise n'appartenant pas à votre groupe. Si un appareil portant cet IMEI vous appartient, veuillez contacter <supportLink>le service d'assistance de Teltonika</supportLink>.",
      "title": "IMEI utilisé par un autre groupe d'entreprises"
    },
    "vehicle name": "Nom du véhicule",
    "vehicle number": "Numéro d'immatriculation du véhicule (VRN)",
    "vehicle registration number tooltip": "La mise à jour automatique est activée dans les paramètres de votre entreprise. Le numéro d'immatriculation (VRN) que vous saisissez ici sera remplacé par la valeur lue à partir des données du tachygraphe après le premier téléchargement réussi.",
    "vehicles folder naming": "Nommer des dossiers de véhicules",
    "vrn": "VRN",
    "vrn should not be empty": "Le numéro d'immatriculation du véhicule ne doit pas être vide",
    "welcome to beta version title": "Bienvenue dans la phase de test bêta de TachoSync !"
  },
  "Download history": {
    "download successful": "Téléchargement réussi",
    "driver data": "Données des conducteurs",
    "no history": "L'historique s'affichera ici",
    "schedule": "Calendrier"
  },
  "Download monitoring": {
    "APDU packet reading error. Device disconnected.": "Erreur de lecture du paquet APDU. Appareil déconnecté.",
    "Authenticating": "Authentification",
    "Authentication failure (02x10)": "Échec de l'authentification (02x10)",
    "Authentication failure after timeout (02x01)": "Échec d'authentification après délai d'expiration (02x01)",
    "Authentication failure after timeout (02x12)": "Échec d'authentification après délai d'expiration (02x12)",
    "Card reading error. Please reinsert the company card, reconnect the card reader, or restart the service.": "Erreur de lecture de la carte. Veuillez réinsérer la carte d'entreprise, reconnecter le lecteur de carte ou redémarrer le service.",
    "CheckingCredits": "Vérification des crédits",
    "CompanyCardExpired": "Carte d'entreprise périmée",
    "CompanyCardInUse": "Carte d'entreprise en cours d'utilisation",
    "Could not download any of files": "Aucun fichier n'a pu être téléchargé",
    "CreditReserved": "Droits réservés",
    "Download rejected: device VIN doesn't match this vehicle's VIN record. If the device was moved to a new vehicle, create a new vehicle record to continue.": "Téléchargement refusé : le numéro d'identification du véhicule (VIN) de l'appareil ne correspond pas à celui enregistré pour ce véhicule. Si l'appareil a été transféré sur un nouveau véhicule, créez une nouvelle fiche véhicule pour continuer.",
    "DownloadingDriverData": "Téléchargement des données des conducteurs",
    "DownloadingDriverDataFailed": "Échec du téléchargement des données du conducteur",
    "DownloadingVehicleData": "Téléchargement des données des véhicules",
    "Driver info packet reading error. Device disconnected.": "Erreur de lecture du dossier d'informations du conducteur. Appareil déconnecté.",
    "Failed to download driver data": "Échec du téléchargement des données du conducteur",
    "Failed to receive APDU from card, timeout exceeded": "Échec de la réception de l'APDU depuis la carte, délai d'attente dépassé",
    "Failed to receive VUReady packet from device, timeout exceeded": "Échec de la réception du paquet VUReady provenant de l'appareil, délai d'attente dépassé",
    "Failed to receive VUReady packet. If problem persists, check the telematics/tacho devices setup.": "Échec de la réception du paquet VUReady. Si le problème persiste, vérifiez la configuration des appareils télématiques/tachygraphiques.",
    "InsufficientCredits": "Crédits insuffisants",
    "Lost connection with device or card": "Perte de connexion avec l'appareil ou la carte",
    "NoCompanyCards": "Pas de cartes d'entreprise",
    "NoDueSchedules": "Pas de calendrier de échéances",
    "NoSchedulesApplied": "Aucun horaire appliqué",
    "ProcessTerminated": "Processus interrompu",
    "ReceivingDownloadList": "Réception de la liste des téléchargements",
    "ReceivingDriverInfo": "Réception des informations relatives aux conducteurs",
    "ReceivingDriversSchedules": "Réception des plannings des conducteurs",
    "ReceivingStatusState": "État de réception",
    "ReceivingVehicleSchedules": "Réception des plannings des véhicules",
    "requirements": {
      "company card": "Carte d'entreprise",
      "credits available": "Crédits disponibles",
      "ignition": "Allumage",
      "ignition unavailable tooltip": "Inconnu - le dernier statut connu remonte à plus de 2 heures.",
      "imei": "IMEI",
      "schedule assigned": "Calendrier attribué",
      "vehicle activated": "Activé par le véhicule",
      "reason": {
        "CompanyCardExpired": "La carte d'entreprise a expiré",
        "IgnitionNotReportedRecently": "Statut inconnu : l'état du contact n'a pas été signalé récemment. Le téléchargement sera tout de même tenté, mais il a peu de chances d'aboutir",
        "IgnitionOff": "Le contact est coupé. Le téléchargement sera tout de même tenté, mais il a moins de chances d'aboutir",
        "InsufficientCredits": "Aucun crédit disponible",
        "NoCompanyCardOnline": "Aucune carte d'entreprise n'est actuellement en ligne",
        "NoCompanyCards": "Aucune carte d'entreprise n'est actuellement en ligne",
        "NoImeiAssigned": "Aucun numéro IMEI n'a été attribué au véhicule",
        "NoScheduleAssigned": "Le véhicule doit avoir un planning qui lui est attribué",
        "VehicleDeactivated": "Le véhicule doit être activé pour pouvoir télécharger les données"
      }
    },
    "schedules": {
      "assign schedules": "Attribuer des plannings",
      "assign schedules dialog": {
        "description": "Sélectionnez un ou plusieurs plannings que vous souhaitez attribuer.",
        "title": "Attribuer des plannings à {{vehicleNumber}}"
      },
      "fail reason": {
        "download requirements not met": "conditions de téléchargement non respectées."
      },
      "no schedules assigned": "Aucun planning n'est attribué à ce véhicule",
      "on device connection": "lors de la connexion de l'appareil",
      "requirements not met": "Le planning ne peut pas être exécuté tant que toutes les conditions ne sont pas remplies."
    },
    "StageComplete": "Étape terminée",
    "Stages": {
      "Authentication": "Authentification",
      "Downloading": "Téléchargement",
      "DownloadTrigger": "Déclencheur de téléchargement",
      "Initialization": "Initialisation"
    },
    "Status packet reading error. Device disconnected.": "Erreur de lecture du paquet d'état. Appareil déconnecté.",
    "TerminatingConnectionToDevice": "Interruption de la connexion à l'appareil",
    "Timeout. Response from VU not received (02x01)": "Délai d'attente. Réponse de l'unité embarquée (VU) non reçue (02x01)",
    "Too many KeepAlive packets received.": "Trop de paquets KeepAlive reçus.",
    "Unexpected error": "Erreur inattendue",
    "Unexpected loss of connection with the device. Once device returns to normal connectivity, download will continue.": "Perte inattendue de la connexion avec l’appareil. Le téléchargement reprendra dès que l’appareil aura retrouvé une connexion normale.",
    "UploadingDriverFiles": "Téléversement des fichiers des conducteurs",
    "UploadingDriverFilesFailed": "Échec du téléchargement des fichiers des conducteurs",
    "UploadingVehicleFiles": "Téléversement des fichiers des véhicules",
    "UploadingVehicleFilesFailed": "Échec du téléchargement des fichiers des véhicules",
    "VehicleDeactivated": "Véhicule désactivé",
    "VuNotReady": "VU non prête. Nouvelle tentative dans 5 minutes",
    "VU ready packet reading error. Device disconnected.": "Erreur de lecture du paquet « VU ready ». Appareil déconnecté.",
    "WaitingForDeviceConnection": "En attente de connexion de l'appareil",
    "Wrong communication command": "Commande de communication incorrecte"
  },
  "Drivers": {
    "drivers page": "Conducteurs",
    "last activity": {
      "Available": "Disponible",
      "BreakOrRest": "Pause/Repos",
      "Drive": "Conduire",
      "NotAvailable": "Non disponible",
      "Undefined": "N/A",
      "Unknown": "Inconnu",
      "Unknown4": "Inconnu",
      "Unknown5": "Inconnu",
      "Work": "Travail"
    }
  },
  "Dropzone": {
    "add file": "Ajouter un fichier",
    "drop file to upload": "déposer le fichier à télécharger",
    "drop files to upload": "déposer les fichiers à télécharger",
    "error uploading the file": "Une erreur s'est produite lors du téléchargement du fichier",
    "file invalid type": "Type de fichier invalide",
    "file successfully uploaded": "Fichier téléchargé avec succès",
    "file syntax": "La syntaxe des fichiers est la suivante :",
    "maximum file limit reached": "La limite maximale de fichiers a été atteinte.",
    "no image": "Pas d'image",
    "only one file can be attached": "Un seul fichier peut être joint.",
    "or drop file to upload": "déposer le fichier pour télécharger",
    "or drop files to upload": "déposer les fichiers pour télécharger",
    "row limit exceeded": "Limite d'importation des ressources atteinte. Vous ne pouvez pas importer plus de {{rowLimit}} ressources.",
    "rows detected": "Lignes du fichier détectées avec succès",
    "select file": "Sélectionner un fichier",
    "select file type": "Veuillez d'abord sélectionner le type de fichier.",
    "select files": "Sélectionner des fichiers",
    "select image": "Sélectionnez une image :",
    "supported formats": "Formats pris en charge",
    "too long file name": "Le nom du fichier est trop long. {{maxLength}} caractères maximum autorisés.",
    "too many files description": "Les autres fichiers peuvent être téléchargés une fois que vous avez téléchargé les fichiers sélectionnés.",
    "too many files title": "Le nombre maximal de fichiers que vous pouvez joindre en une seule fois est de {{maxFiles}}."
  },
  "Error": {
    "error": "Erreur",
    "message wait": "Merci de patienter le temps que nous corrigions l'erreur",
    "title": "Une erreur s'est produite !"
  },
  "Files": {
    "files header info tooltip": "Les fichiers téléchargés sont conservés dans TachoSync pendant deux ans, après,  ils sont automatiquement supprimés du système."
  },
  "Filter": {
    "company": "Entreprise",
    "credit status": "Situation de crédit",
    "deactivatedVehicles": "Véhicules désactivés",
    "device imei": "IMEI de l'appareil",
    "device status": "État de l'appareil",
    "driver": "Conducteur",
    "filtered by": "Filtré par",
    "filters used": "Filtres utilisés",
    "from to date": "{{fromDate}} au {{toDate}}",
    "last activity": "Dernière activité",
    "last download": "Dernier téléchargement",
    "last download options": {
      "DueSoon": "À venir",
      "NoDownloads": "Aucun téléchargement",
      "OnTime": "À l'heure",
      "Overdue": "En retard",
      "Undefined": "N/A"
    },
    "more filters": "Plus de filtres",
    "noDeviceImei": "Aucun numéro IMEI",
    "Not reserved": "Non réservé",
    "Reserved": "Réservé",
    "schedule": "Calendrier",
    "schedule name": "Nom du calendrier",
    "schedules": "Calendrier",
    "select date": "Sélectionner une date",
    "select date and time": "Sélectionnez la date et l'heure",
    "Select date range": "Sélectionner une période",
    "status": "Statut",
    "table filters": "Filtres de tableau",
    "vehicle number": "Numéro de véhicule"
  },
  "General": {
    "Active": "Actif",
    "Administrator": "Administrateur",
    "administrator role description": "Contrôle total pour créer, modifier et supprimer toutes les ressources.",
    "analysis provider": "Fournisseur d'analyses",
    "analysis providers": "Prestataires d'analyses",
    "api credential": "Identifiant API",
    "api credentials": "Identifiants API",
    "Available": "Disponible",
    "Awaiting connection": "En attente de connexion",
    "badge": {
      "connected badge tooltip text": "Connexion à TachoSync établie et communication active.",
      "deactivated badge tooltip text": "Ce véhicule est désactivé et ne consommera pas de crédits.",
      "inactive badge tooltip text": "La connexion avec TachoSync n'a jamais abouti.",
      "offline badge tooltip text": "N'a pas été connecté à TachoSync au cours des dernières 24 heures",
      "online badge tooltip text": "Connecté au cours des dernières 24 heures"
    },
    "Blocked": "Bloqué",
    "BreakOrRest": "Pause/Repos",
    "business": "Entreprise",
    "code expired": "Votre session a expiré. Veuillez vous reconnecter.",
    "column": "Rubrique",
    "companies": "Entreprises",
    "company": "Entreprise",
    "Company administrator": "Administrateur de l'entreprise",
    "Connected": "Connecté",
    "credits": "Crédits",
    "dashboard": "Tableau de bord",
    "Deactivated": "Désactivé",
    "Description": "Description",
    "Disabled": "Désactivé",
    "Disconnected": "Hors ligne",
    "Drive": "Conduite",
    "driver data": "Données des conducteurs",
    "drivers": "Conducteurs",
    "DueSoon": "À venir",
    "end": "Fin",
    "Expired": "Expiré",
    "Failed": "Échec",
    "files": "Fichiers",
    "here": "ici",
    "history": "Historique",
    "Inactive": "Inactif",
    "in progress": "en cours",
    "integration": "Intégration",
    "integrations": "Intégrations",
    "integrations/analysisProviders": "Prestataires d'analyses",
    "integrations/apicredentials": "Identifiants API",
    "Interrupted": "Interrompu",
    "InvalidConfiguration": "Échec",
    "invitations": "Invitations",
    "latest version": "Dernière version",
    "menu": "Menu",
    "NoDownloads": "Aucun téléchargement",
    "not assigned": "Non attribué",
    "Not reserved": "Non réservé",
    "NotAvailable": "Non disponible",
    "NotReserved": "Non réservé",
    "Offline": "Hors ligne",
    "Online": "En ligne",
    "OnTime": "À l'heure",
    "Pending": "En attente",
    "requirements": "Exigences",
    "Reserved": "Réservé",
    "row": "Ligne",
    "schedule": "Calendrier",
    "schedules": "Calendriers",
    "show older": "Afficher les plus anciens",
    "start": "Démarrer",
    "Successful": "Réussite",
    "Teltonika support": "Assistance Teltonika",
    "Teltonika Support": "Assistance Teltonika",
    "teltonika support role description": "Accès réservé au support technique.",
    "Tooltip": {
      "accept beta terms": "Pour continuer, faites défiler vers le bas et acceptez les conditions."
    },
    "unauthorized": "Échec de l'authentification de l'utilisateur",
    "Undefined": "N/A",
    "Unknown": "Inconnu",
    "Unknown4": "Inconnu",
    "Unknown5": "Inconnu",
    "User": "Utilisateur",
    "user role description": "Accès de base avec des autorisations limitées.",
    "users": "Utilisateurs",
    "vehicles": "Véhicules",
    "Work": "Travail",
    "year": "Année"
  },
  "Languages": {
    "english": "Anglais",
    "french": "Français",
    "language": "Langue"
  },
  "Navigation": {
    "collapse menu": "Réduire le menu",
    "expand menu": "Développer le menu"
  },
  "News": {
    "create news": "Créer une actualité",
    "delete": "Supprimer",
    "edit": "Modifier",
    "publish": "Publier",
    "unpublished": "Non publié"
  },
  "Notifications": {
    "notifications": "Notifications"
  },
  "Password": {
    "account password": "Mot de passe du compte",
    "are you sure": "Êtes-vous sûr ?",
    "change": "Modifier",
    "change password": "Modifier le mot de passe",
    "click to scan code": "Cliquez ici pour scanner un code QR à la place",
    "click to type code": "Cliquez ici pour saisir le code manuellement",
    "disable description confirmation": "Vous êtes sur le point de désactiver votre authentification à deux facteurs. Cela pourrait compromettre la sécurité de votre compte TachoSync. Voulez-vous vraiment continuer ?",
    "disable description send code": "Un code à 6 chiffres a été envoyé à votre application d'authentification. Pour des raisons de sécurité, veuillez saisir le code généré dans le champ ci-dessous.",
    "disable description send password": "Pour des raisons de sécurité, veuillez saisir à nouveau votre mot de passe actuel.",
    "disable no access": "Si vous n'avez plus accès à l'application d'authentification liée à ce compte, vous devez modifier votre mot de passe pour désactiver l'authentification à deux facteurs.",
    "disabled": "Désactivé",
    "disabled two FA": "L'authentification à deux facteurs a été désactivée avec succès.",
    "enabled": "Activé",
    "enter": "Entrer",
    "enter current password": "Entrez le mot de passe actuel",
    "generate key description": "Vous aurez besoin d'une application mobile d'authentification pour mener à bien cette procédure, telle qu'une des suivantes :",
    "incorrect code": "Code incorrect",
    "incorrect password": "Mot de passe incorrect",
    "lowercase letter": "Au moins une lettre minuscule (a-z)",
    "minimum characters": "Au moins {{maxNumber}} caractères",
    "minimum digits": "Au moins un numéro",
    "password": "Mot de passe",
    "password too long": "Le mot de passe ne peut pas dépasser  {{maxNumber}} caractères",
    "passwords must match": "Les mots de passe doivent correspondre",
    "reset password success": "Votre mot de passe a été modifié.",
    "scan QR code": "Scannez le code QR dans votre application",
    "six digit code": "Code à 6 chiffres généré par votre application",
    "special character": "Au moins un caractère spécial (!@#$%^&*()-_=+)",
    "success description": "Vous avez activé l'authentification à deux facteurs.",
    "two-factor authentication": "Authentification à deux facteurs",
    "two-factor authentication description": "L'authentification à deux facteurs est un niveau de sécurité supplémentaire qui vérifie votre identité à l'aide d'un élément que vous connaissez (mot de passe) et d'un élément que vous possédez (téléphone, clé de sécurité).",
    "two-factor authentication enabled": "L'authentification à deux facteurs a été activée avec succès.",
    "two-factor authentication status": "L'authentification à deux facteurs, c'est :",
    "type text code": "Saisissez le code texte dans votre application",
    "uppercase letter": "Au moins une lettre majuscule (A-Z)"
  },
  "Schedules": {
    "activities from": "Activités de",
    "activities to": "Activités liées à",
    "apply button tooltip": "Sélectionnez au moins un {{resourceName}} et planifiez l'application.",
    "confirm bulk quick schedule": "Vous êtes sur le point de créer un planning rapide pour les conducteurs sélectionnés. Souhaitez-vous continuer ?",
    "confirm close": {
      "description": {
        "drivers": {
          "not selected": "Vous avez sélectionné des conducteurs, mais aucun planning n'a été choisi ni appliqué. Voulez-vous vraiment continuer ?",
          "selected": "Vous avez sélectionné un planning, mais vous ne l'avez pas appliqué. Souhaitez-vous appliquer ce planning aux conducteurs sélectionnés ?"
        },
        "vehicles": {
          "not selected": "Vous avez sélectionné des véhicules, mais aucun planning n'a été choisi ni appliqué. Êtes-vous sûr de vouloir continuer ?",
          "selected": "Vous avez sélectionné un planning, mais vous ne l'avez pas appliqué. Souhaitez-vous appliquer ce planning aux véhicules sélectionnés ?"
        }
      },
      "title": {
        "not selected": "Aucun calendrier n'a été sélectionné ou appliqué.",
        "selected": "Calendrier non appliqué."
      }
    },
    "confirm delete": {
      "description": {
        "drivers": "Êtes-vous sûr de vouloir supprimer l'horaire « {{scheduleName}} » ? Cette action est irréversible et affectera tous les conducteurs auxquels cet horaire est appliqué.",
        "vehicles": "Voulez-vous vraiment supprimer le planning « {{scheduleName}} » ? Cette action est irréversible et affectera tous les véhicules auxquels ce planning est appliqué."
      },
      "title": "Supprimer le calendrier ?"
    },
    "create new schedule": "Créer un nouvel calendrier",
    "data types": "Types de données",
    "days": "jours",
    "details remove schedule": {
      "description": "Êtes-vous sûr de vouloir supprimer le planning « {{scheduleName}} » ?",
      "title": "Supprimer le calendrier ?"
    },
    "download activities": {
      "date info tooltip": "La période d'activité doit couvrir au moins deux jours.",
      "tooltip text": "TachoSync utilise une fenêtre de téléchargement adaptative qui garantit la continuité en ajustant automatiquement la période de téléchargement en fonction de la dernière récupération de données réussie. Cela réduit les lacunes et vous assure de toujours disposer des données les plus récentes, même si aucun téléchargement programmé n'a été effectué depuis plusieurs jours."
    },
    "driver number": "Conducteur {{driverNum}}",
    "driver schedules": {
      "description": "Les emplois du temps des chauffeurs vous permettent d'automatiser le téléchargement des données de l'appareil de contrôle pour certains chauffeurs. Sélectionnez les chauffeurs auxquels vous souhaitez appliquer un emploi du temps. Choisissez un emploi du temps dans la liste et cliquez sur « Appliquer » pour l'activer. Vous pouvez créer, modifier et supprimer des emplois du temps selon vos besoins. Remarque : chaque entreprise peut avoir jusqu'à 3 horaires pour ses chauffeurs à la fois.",
      "description read-only": "Les emplois du temps  des chauffeursvous permettent d'automatiser le téléchargement des données du tachygraphe pour certains conducteurs. Les administrateurs de l'entreprise peuvent créer, modifier et supprimer des plannings selon les besoins.",
      "title": "Les emplois des chauffeurs"
    },
    "due date": "Date d'échéance",
    "edit schedule": {
      "description": {
        "drivers": {
          "global": "Le calendrier global sera automatiquement appliqué à tous les nouveaux conducteurs ajoutés. Ce paramètre peut être modifié dans les paramètres généraux.",
          "not global": "Les modifications apportées à ce planning concerneront tous les conducteurs auxquels ce planning s'applique."
        },
        "vehicles": {
          "global": "Le calendrier global sera automatiquement appliqué à tous les véhicules nouvellement ajoutés. Ce paramètre peut être modifié dans les paramètres généraux.",
          "not global": "Les modifications apportées à ce programme affecteront tous les véhicules auxquels ce programme s'applique."
        }
      },
      "title": {
        "global": "Calendrier mondial",
        "not global": "Modifier le calendrier"
      }
    },
    "enter days": "Saisir les jours",
    "every": "Chaque",
    "fail reason": "Motif de l'échec",
    "file types": {
      "Activities": "Activités",
      "DetailedSpeed": "Vitesse détaillée",
      "EventsAndFaults": "Événements et défauts",
      "Overview": "Aperçu",
      "TechnicalData": "Caractéristiques techniques"
    },
    "global schedule": {
      "connected to root company": "Connecté au calendrier global de la société mère.",
      "global icon info": "Le calendrier global s'appliquera automatiquement à tous les nouveaux utilisateurs enregistrés {{specificGlobalSchedule}}. Vous pouvez désactiver cette option dans les paramètres de l'entreprise.",
      "info": {
        "edit driver schedule": "Le calendrier global s'appliquera automatiquement à tous les conducteurs nouvellement enregistrés. Vous pouvez désactiver cette option dans les paramètres de l'entreprise.",
        "edit schedule": "Le calendrier global s'appliquera automatiquement à tous les {{ variableName }} nouvellement enregistrés. Vous pouvez désactiver cette option dans les paramètres de l'entreprise.",
        "edit vehicle schedule": "Le calendrier global s'appliquera automatiquement à tous les véhicules nouvellement enregistrés. Vous pouvez désactiver cette option dans les paramètres de l'entreprise."
      },
      "inherited settings": "Les paramètres de calendrier globaux de la société mère sont automatiquement hérités par toutes les filiales.",
      "not configured description": "Appuyez sur le bouton Modifier pour commencer à configurer le calendrier global.",
      "not configured description read-only": "Les détails du calendrier s'afficheront une fois celui-ci configuré.",
      "not configured title": "Calendrier global non configuré.",
      "not connected to root company": "Non connecté au calendrier global de la société mère."
    },
    "include driver data": "Inclure les données des conducteurs",
    "include driver data tooltip": "Indiquez si le planning rapide doit également télécharger les données de la carte de conducteur pour le ou les conducteurs dont la carte est actuellement insérée dans le tachygraphe au moment de l'exécution.\n<ul><li>Aucun – Seules les données du véhicule (VU) seront téléchargées.</li><li>Conducteur 1 / Conducteur 2 – Télécharge les données de l'emplacement sélectionné du tachygraphe si une carte de conducteur est présente.</li><li>Les deux conducteurs – Télécharger les données des deux emplacements si des cartes sont présentes.</li></ul>Si aucune carte de conducteur n'est insérée dans l'emplacement sélectionné lors de l'exécution, les données du conducteur ne seront pas téléchargées.",
    "max number reached": "Vous avez atteint le nombre maximal des heures/horaires autorisés.",
    "name not valid": "Le nom du calendrier ne peut pas contenir plus de {{maxNumber}} caractères",
    "next attempt": "Nouvelle tentative",
    "next date": "Prochaine date",
    "next date and time": "Date et heure suivantes",
    "next due date": "Prochaine date d'échéance",
    "quick schedule": {
      "description": "Sélectionnez les types de données que vous souhaitez télécharger.",
      "driver schedule quick download new": "Crée une calendrier ponctuelle pour le téléchargement des fichiers du conducteur. Elle sera exécutée dès que le conducteur se connectera à l'application.",
      "info banner": {
        "drivers": "Il s'agit d'une calendrier ponctuelle. Le téléchargement des données du conducteur sera lancé dès que la connexion du conducteur à TachoSync sera détectée.",
        "vehicles": "Il s'agit d'une calendrier ponctuelle. Le téléchargement des données du véhicule sera lancé dès que la connexion du véhicule à TachoSync sera détectée."
      },
      "success banner": "Le planning a été finalisé, vous pouvez le supprimer en cliquant sur « Supprimer le planning »",
      "title": "Calendrier rapide",
      "vehicle schedule quick download deactivated": "Il n'est pas possible de lancer le calendrier rapide sur des véhicules désactivés. Si vous souhaitez démarrer un nouveau planning rapide, activez d'abord le véhicule.",
      "vehicle schedule quick download new": "Crée une calendrier ponctuelle pour le téléchargement des fichiers du véhicule. Elle sera exécutée dès que le véhicule se connectera à l'application."
    },
    "repeat": "Répéter",
    "repeat every": "Répéter toutes les",
    "repeat period": {
      "Biweekly": "Tous les 14 jours",
      "Custom": "Personnalisé",
      "Daily": "Quotidien",
      "Every28Days": "Tous les 28 jours",
      "Every90Days": "Tous les 90 jours",
      "EveryDays": "Tous les {{count}} jours",
      "Hourly": "À l'heure",
      "Monthly": "Mensuel",
      "Weekly": "Tous les 7 jours"
    },
    "schedule details": "Détails de « {{scheduleName}} »",
    "select date": "Sélectionner une date",
    "start date": "Date de début",
    "start date and time": "Date et heure de début",
    "vehicle schedules": {
      "description": "Les calendriers de véhicules vous permettent d'automatiser le téléchargement des données du tachygraphe pour les véhicules sélectionnés. Sélectionnez les véhicules auxquels vous souhaitez appliquer un planning. Choisissez un planning dans la liste et cliquez sur « Appliquer » pour l'activer. Vous pouvez créer, modifier et supprimer des plannings selon vos besoins. Remarque : chaque entreprise peut avoir jusqu'à 3 plannings de véhicules à la fois.",
      "description read-only": "Les calendriers de véhicules vous permettent d'automatiser le téléchargement des données du tachygraphe pour les véhicules sélectionnés. Les administrateurs de l'entreprise peuvent créer, modifier et supprimer des calendriers selon les besoins.",
      "download data activities tooltip hourly": "Les activités seront téléchargées pour la journée en cours",
      "download data activities tooltip monthly": "Les activités seront téléchargées pour l'intégralité du mois écoulé précédant chaque date d'exécution",
      "download data activities tooltip multiple": "Les activités seront téléchargées pour les {{repeatDays}} derniers jours précédant chaque date d'exécution",
      "download data activities tooltip single": "Les activités seront téléchargées pour le dernier jour précédant chaque date d'exécution",
      "title": "Horaires des véhicules"
    }
  },
  "Search": {
    "find device": {
      "error not valid": "L'IMEI doit comporter 15 caractères",
      "find device": "Rechercher un boitier",
      "no vehicle found": "Aucun véhicule trouvé",
      "no vehicle found description": "Véhicule introuvable. Veuillez saisir l'IMEI d'un autre appareil.",
      "only numbers": "Seuls les chiffres sont valides",
      "search for vehicles by their IMEI": "Recherche de véhicules par numéro IMEI de leur appareil",
      "search vehicle IMEI": "Rechercher l'IMEI d'un appareil"
    },
    "search": "Rechercher...",
    "search child company": "Rechercher une filiale",
    "search company name": "Rechercher le nom de l'entreprise",
    "search in driverFiles": "Recherche par conducteur ou par identifiant de conducteur",
    "search in drivers": "Recherche par nom ou par identifiant de conducteur",
    "search in integrations": "Recherche par nom",
    "search in users": "Recherche par e-mail",
    "search in vehicleFiles": "Recherche par IMEI ou VRN de l'appareil FM",
    "search in vehicles": "Recherche par numéro IMEI ou VRN de l'appareil FM"
  },
  "Security": {
    "2FA": {
      "get email code": {
        "description": "Utilisez ce code sur l'écran suivant pour vérifier votre compte.",
        "description modal": "Utilisez ce code pour vérifier votre compte.",
        "title": "En cliquant sur « Envoyer le code », un code unique sera envoyé à <1>{{email}}</1>."
      },
      "select authentication type": {
        "authentication app description": "Obtenez un code unique à partir d'une application telle que Microsoft Authenticator ou Google Authenticator.",
        "description": "Pour garantir la sécurité de votre compte et des données de vos clients, veuillez utiliser l'une des options suivantes pour configurer l'authentification à deux facteurs.",
        "description modal": "Sélectionnez votre méthode d'authentification préférée.",
        "email": "E-mail",
        "email description": "Nous vous enverrons un code à usage unique par e-mail chaque fois que vous tenterez de vous connecter.",
        "recommended": "Recommandé",
        "title": "L'authentification à deux facteurs (2FA) est obligatoire pour tous les utilisateurs de TachoSync.",
        "title modal": "Sélectionnez une méthode d'authentification"
      },
      "send email code": {
        "description": "Veuillez saisir le code dans le champ ci-dessous, puis cliquez sur « Vérifier » pour continuer.",
        "enter code": "Veuillez saisir le code pour vérifier l'adresse e-mail.",
        "title": "Un code unique a été envoyé à <1>{{email}}</1>.",
        "verification code": "Code de vérification"
      },
      "send otp code": {
        "click to scan code": "Cliquez ici pour scanner un code QR à la place",
        "click to type code": "Cliquez ici pour saisir le code manuellement",
        "incorrect code": "Code incorrect",
        "scan QR code": "Scannez le code QR dans votre application",
        "six digit code": "Code à 6 chiffres généré par votre application",
        "title": "Vous aurez besoin d'une application mobile d'authentification pour mener à bien cette procédure, telle que : <1>Microsoft Authenticator</1> ou <2>Google Authenticator</2>.",
        "type text code": "Saisissez le code texte dans votre application"
      },
      "success message": {
        "alert": "L'authentification à deux facteurs a été activée avec succès.",
        "description": "Nous vous demanderons un code d'authentification à chaque fois que vous vous connecterez avec votre adresse e-mail et votre mot de passe.",
        "title": "Vous avez activé l'authentification à deux facteurs.",
        "title modal": "Authentification à deux facteurs activée !"
      },
      "title": {
        "authentication app": "Application d'authentification",
        "authentication email": "E-mail d'authentification",
        "is enabled": "Authentification à deux facteurs activée.",
        "protect your account": "Protégez votre compte TachoSync"
      }
    }
  },
  "Selector": {
    "client company": "Entreprise cliente",
    "companies": "Entreprises ({{companyCount}})",
    "company selector": "Sélecteur d'entreprise"
  },
  "Settings": {
    "CCA file size": "Taille du fichier : 83,5 Mo",
    "change password": "Modifier le mot de passe",
    "company card authenticator": "Authentificateur de carte d'entreprise",
    "email notifications": {
      "credits purchased": "Crédits achetés",
      "low credits alerts": "Alertes de solde insuffisant",
      "title": "Notifications par e-mail",
      "tooltip": "Gérez les e-mails liés à votre crédit que vous recevez."
    },
    "feature switches": "Commutateurs de fonctionnalités",
    "file format settings": {
      "description": "Choisissez le format d'affichage des fichiers du tachygraphe. Les formats disponibles sont le format européen (.DDD), le format français (.V1B pour les données du véhicule et .C1B pour les données du conducteur) et le format espagnol (.TGD).",
      "title": "Paramètres de format de fichier"
    },
    "file formats": {
      "DDD": ".DDD",
      "TGD": ".TGD",
      "V1BC1B": ".V1B, .C1B"
    },
    "general settings": "Paramètres généraux",
    "security": "Sécurité",
    "time settings": {
      "date display format tooltip": "Sélectionnez un format d'affichage de la date dans TachoSync.\nEx. : JJ-MM-AAAA = 14-05-2024",
      "description": "Définissez automatiquement le fuseau horaire en fonction de votre position actuelle, ou choisissez votre fuseau horaire préféré et le format d'affichage de tous les horodatages.",
      "time and date format toggle": "Définir automatiquement le format de l'heure et de la date",
      "title": "Réglages de l'heure"
    },
    "tutorials": "Tutoriels",
    "version": "Version"
  },
  "Table": {
    "activity period": "Période d'activité",
    "Automatic initial Driver Download": "Téléchargement automatique des données initiales du conducteur",
    "Automatic initial Vehicle Download": "Téléchargement automatique des données initiales du véhicule",
    "card name": "Nom",
    "card number": "Identifiant du conducteur",
    "cardnumber": "Identifiant du conducteur",
    "comment": "Commentaire",
    "company": "Entreprise",
    "connection status": "État de la connexion",
    "created at": "Créé le",
    "created by": "Créé par",
    "credit status": "Situation de crédit",
    "data types": "Types de données",
    "day ago": "Il y a 1 jour",
    "days ago": "Il y a {{daysNum}} jours",
    "description": "Description",
    "device imei": "IMEI de l'appareil",
    "device imei empty": "Aucun IMEI n'est associé à ce véhicule. Un IMEI valide est nécessaire pour connecter l'appareil et télécharger les fichiers. Accédez à la page de modification du véhicule et ajoutez un IMEI valide pour permettre le téléchargement des fichiers du véhicule.",
    "device status": "État de l'appareil",
    "downloaded at": "Téléchargé le",
    "driver": "Conducteur",
    "driver name": "Nom du conducteur",
    "drivers name": "Nom du conducteur",
    "email": "E-mail",
    "empty table": {
      "button": {
        "add": {
          "analysis providers": "Ajouter une intégration",
          "driver files": "Ajouter un fichier de conducteur",
          "drivers": "Ajouter un conducteur",
          "integrations": "Ajouter une intégration",
          "integrations api": "Ajouter une intégration",
          "users": "Inviter un utilisateur",
          "vehicle files": "Ajouter un fichier de véhicule",
          "vehicles": "Ajouter un véhicule"
        },
        "reset view": "Réinitialiser l'affichage"
      },
      "no initial results": {
        "description": {
          "analysis providers": "Dès que des prestataires d'analyse seront ajoutés à TachoSync, \nvous pourrez consulter la liste ici.",
          "companies": "une fois les entreprises seront ajoutées à TachoSync,\nvous pourrez consulter la liste ici.",
          "company cards": "Une fois les fiches d'entreprise ajoutées, vous pourrez consulter la liste ici.",
          "driver files": "une fois les fichiers des conducteurs seront ajoutés à TachoSync,",
          "drivers": "Une fois vous pourrez consulter la liste ici.",
          "integrations": "une fois des nouvelles intégrations seront ajoutées à TachoSync, \nvous pourrez consulter la liste ici.",
          "integrations api": "Dès que des clés API seront créées pour votre entreprise,\nvous pourrez consulter la liste ici.",
          "users": "Une fois les utilisateurs seront ajoutés à TachoSync, vous \npourrez consulter la liste ici.",
          "users invitations": "Une fois les utilisateurs seront ajoutés à TachoSync, vous \npourrez consulter la liste ici.",
          "vehicle files": "Une fois les utilisateurs seront ajoutés à TachoSync, vous \npourrez consulter la liste ici.",
          "vehicles": "Une fois les utilisateurs seront ajoutés à TachoSync, vous \npourrez consulter la liste ici."
        },
        "title": {
          "analysis providers": "Aucun fournisseur d'analyses pour le moment",
          "companies": "Le tableau des entreprises est vide",
          "company cards": "Le tableau des cartes d'entreprise est vide",
          "driver files": "Le tableau des fichiers conducteurs est vide",
          "drivers": "Le tableau des conducteurs est vide",
          "integrations": "Aucune intégration pour le moment",
          "integrations api": "Aucune clé API pour le moment",
          "users": "Le tableau des utilisateurs est vide",
          "users invitations": "Le tableau des invitations d'utilisateurs est vide",
          "vehicle files": "Le tableau des fichiers des véhicules est vide",
          "vehicles": "Le tableau des véhicules est vide"
        }
      },
      "no results found": {
        "description": "Essayez un autre mot-clé ou filtre pour obtenir plus de \nrésultats.",
        "title": "Aucun résultat trouvé"
      }
    },
    "enable": "Activer",
    "expiration date": "Date d'expiration",
    "expired integration tooltip": "L'intégration a expiré et ne peut pas etre activée",
    "file name": "Nom du fichier",
    "Global schedule": "Calendrier mondial",
    "imei": "IMEI",
    "invitation status": "Statut de l'invitation",
    "invited at": "Invité à",
    "invited by": "À l'invitation de",
    "last activity": "Dernière activité",
    "last connected": "Dernière connexion",
    "last connection": "Dernière connexion",
    "last download": "Dernier téléchargement",
    "last download date": "Dernier téléchargement : {{date}}",
    "last event": "Dernier événement",
    "last vehicle used": "Dernier véhicule utilisé",
    "method": "Méthode",
    "name": "Nom",
    "next download": "Téléchargement suivant",
    "No schedule applied": "Aucun calendrier appliqué",
    "No schedules": "Pas d'horaires",
    "number": "Nombre",
    "Overdue": "En retard",
    "parent company": "Société mère",
    "plate number": "Numéro d'immatriculation",
    "provider": "Fournisseur",
    "Quick schedule": "Calendrier rapide",
    "role": "Rôle",
    "rows per page": "Lignes par page",
    "schedule": "Calendrier",
    "schedules": "Horaires",
    "seen at": "Vu sur",
    "select columns to show": "Sélectionner les colonnes à afficher",
    "show details": {
      "companies": "Afficher les coordonnées de l'entreprise",
      "drivers": "Afficher les détails du conducteur",
      "integrations": "Afficher les détails de l'intégration",
      "vehicles": "Afficher les détails du véhicule"
    },
    "status": "Statut",
    "today": "Aujourd'hui",
    "updated at": "Mis à jour le",
    "vehicle": "Véhicule",
    "vehicle name": "Nom du véhicule",
    "vehicle number": "VRN",
    "vehicles": "Véhicules"
  },
  "Tabs": {
    "analysis providers": "Prestataires d'analyses",
    "api": "API",
    "invitations": "Invitations",
    "sftp": "SFTP",
    "users": "Utilisateurs"
  },
  "Tooltip": {
    "delete company action": "Une ou plusieurs des entreprises sélectionnées ont des filiales et ne peuvent pas être supprimées. Supprimez d'abord toutes les filiales afin de pouvoir supprimer les entreprises sélectionnées.",
    "no action permission": "Vous n'avez pas l'autorisation d'effectuer cette action",
    "parent company": "Le nombre maximal de niveaux autorisés dans l'arborescence d'une entreprise est {{maxAllowedLevels}}. L'entreprise « {{companyName}} » se trouve au {{maxAllowedLevels}}e niveau et ne peut plus accueillir de filiales."
  },
  "Tutorials": {
    "add company card": {
      "desktop": {
        "fifth step": {
          "content": "Pour ajouter une nouvelle carte d'entreprise, cliquez sur le bouton «<strong> Ajouter une nouvelle carte</strong> » mis en évidence. Lorsque l'écran d'ajout d'entreprise s'affiche, remplissez les champs obligatoires, puis cliquez sur le bouton « Enregistrer » pour terminer.\n\nRemarque : l'ID de la carte d'entreprise se trouve dans l'authentificateur de carte d'entreprise, dans la colonne « ID de la carte ».\n\nCliquez sur « <strong>Suivant</strong> » pour continuer.",
          "title": "Ajouter une nouvelle fiche d'entreprise"
        },
        "final step": {
          "content": "Toutes les cartes ajoutées et leurs détails seront répertoriés sous « Cartes d'entreprise ».\n\nRemarque : vous pouvez à tout moment revoir ce tutoriel en vous rendant dans « Paramètres » - « Tutoriels ». \n\nCliquez sur « <strong>Terminer</strong> » pour terminer le tutoriel.",
          "title": "Coordonnées de la société"
        },
        "first step": {
          "content": "Avant d'ajouter une carte d'entreprise dans TachoSync, assurez-vous d'avoir téléchargé et installé l'authentificateur de carte d'entreprise. Vous pouvez le faire à tout moment depuis le menu Paramètres.\n\nL'authentificateur de carte d'entreprise lira et affichera les informations des cartes d'entreprise insérées dans votre lecteur de carte et permettra l'authentification à distance.\n\nCliquez sur «<strong> Commencer</strong> » pour démarrer.",
          "title": "Authentificateur de carte d'entreprise"
        },
        "fourth step": {
          "content": "À droite, vous pouvez voir le panneau contenant les détails de l'entreprise. Vous y trouverez toutes les informations relatives à l'entreprise créée.\n\nCliquez sur « <strong>Suivant</strong> » pour continuer.",
          "title": "Coordonnées de l'entreprise"
        },
        "second step": {
          "content": "À l'aide de la barre latérale gauche, accédez à la page <strong>Entreprises</strong> mise en évidence.",
          "title": "Page Entreprises"
        },
        "third step": {
          "content": "Pour afficher l'écran des fiches d'entreprise, vous devez d'abord cliquer sur l'une des entreprises.\n\nPour ce tutoriel, sélectionnez l'entreprise mise en surbrillance, qui se trouve en haut du tableau.",
          "title": "Choisissez une entreprise"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Pour ajouter une nouvelle carte d'entreprise, cliquez sur le bouton « Ajouter une nouvelle carte » mis en évidence. Lorsque l'écran d'ajout d'entreprise s'affiche, remplissez les champs obligatoires, puis cliquez sur le bouton « Enregistrer » pour terminer.\n\nRemarque : l'ID de la carte d'entreprise se trouve dans l'authentificateur de carte d'entreprise, dans la colonne « ID de la carte ».\n\nCliquez sur « <strong>Suivant</strong> » pour continuer.",
          "title": "Ajouter une nouvelle fiche d'entreprise"
        },
        "final step": {
          "content": "Toutes les cartes ajoutées seront répertoriées sous la rubrique « Cartes d'entreprise » mise en évidence. Vous y verrez le statut de la carte, sa date de validité et son identifiant.\n\nRemarque : vous pouvez à tout moment revoir ce tutoriel en vous rendant dans « Paramètres » - « Tutoriels ». \n\nCliquez sur « <strong>Terminer</strong> » pour terminer le tutoriel.",
          "title": "Coordonnées de la société"
        },
        "first step": {
          "content": "Nous devons d'abord nous rendre sur la <strong>page « Entreprises</strong> », qui se trouve dans le menu, en haut à droite.\n\nCliquez sur la zone surlignée pour ouvrir le <strong>menu</strong>.",
          "title": "Ouvrir le menu"
        },
        "fourth step": {
          "content": "Vous trouverez ici toutes les informations concernant la société créée.\n\nCliquez sur « <strong>Suivant</strong> » pour continuer.",
          "title": "Coordonnées de l'entreprise"
        },
        "second step": {
          "content": "Pour ouvrir la <strong>page Entreprises</strong>, cliquez sur la zone surlignée.",
          "title": "Page Entreprises"
        },
        "third step": {
          "content": "Vous trouverez ici la liste de toutes les entreprises.\nPour consulter la fiche d'une entreprise, ouvrez l'écran <strong>des détails de l'entreprise</strong> en cliquant sur le bouton surligné.",
          "title": "Plus d'informations"
        }
      },
      "name": "Ajouter une carte d'entreprise"
    },
    "add vehicle": {
      "first step": {
        "content": "Pour pouvoir appliquer un planning, vous devez avoir ajouté au moins un véhicule.\n\nAjoutons un véhicule en cliquant sur le bouton « <strong>Ajouter un véhicule</strong> » mis en évidence.\n\nSur l'écran suivant, remplissez tous les champs obligatoires et cliquez sur le bouton « <strong>Ajouter</strong> » pour terminer l'ajout d'un véhicule.",
        "title": "Aucun véhicule ajouté"
      },
      "name": "Ajouter un véhicule"
    },
    "apply schedule": {
      "desktop": {
        "fifth step": {
          "content": "Une fois que vous avez sélectionné un calendrier, le bouton « Appliquer » devient actif.\n\nCliquez sur le bouton « Appliquer ».\n\nCliquez sur <strong>« Suivant</strong> » pour continuer.",
          "title": "Sélectionnez un calendrier à appliquer"
        },
        "final step": {
          "content": "Lorsqu'un planning est correctement appliqué à un véhicule, le téléchargement des données commence à l'heure prévue.\n\nTous les plannings appliqués à un véhicule ou à un conducteur s'affichent dans le panneau « Plus de détails » mis en évidence.\n\nCliquez sur « <strong>Terminer</strong> » pour terminer le tutoriel.",
          "title": "Calendrier correctement appliqué"
        },
        "first step": {
          "content": "Les plannings des véhicules se trouvent sur la page Véhicules, tandis que ceux des conducteurs se trouvent sur la page Conducteurs.\n\nComme la procédure est similaire sur les deux pages, pour ce tutoriel, sélectionnez la page « <strong>Véhicules</strong> » mise en surbrillance.",
          "title": "Calendrier des véhicules ou des conducteurs"
        },
        "fourth step": {
          "content": "Cliquez sur un planning pour l'appliquer au(x) véhicule(s) sélectionné(s).\n\nCliquez sur « Suivant » pour continuer",
          "title": "Sélectionnez un calendrier à appliquer"
        },
        "second step": {
          "content": "Avant d'appliquer un planning, sélectionnez un ou plusieurs véhicules.\n\nPour ce tutoriel, sélectionnez le <strong>premier véhicule du tableau </strong> en cliquant sur le bouton surligné.",
          "title": "Sélectionnez un véhicule"
        },
        "third step": {
          "content": "Maintenant que vous avez sélectionné un véhicule, le bouton « Horaires » devient actif.\n\nCliquez sur le bouton « <strong>Horaires</strong> » surligné pour continuer.",
          "title": "Horaires ouverts"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Maintenant que vous avez sélectionné un véhicule, le bouton « Horaires » devrait s'afficher en surbrillance.\n\nCliquez sur le bouton « <strong>Horaires</strong> » en surbrillance pour continuer.",
          "title": "Horaires ouverts"
        },
        "final step": {
          "content": "Lorsqu'un planning est correctement appliqué à un véhicule, le téléchargement des données commence à l'heure prévue.\nTous les plannings appliqués à un véhicule ou à un conducteur s'affichent dans le panneau « <strong>Plus de détails</strong> » mis en évidence.\n\nCliquez sur « <strong>Terminer</strong> » pour terminer le tutoriel.",
          "title": "Calendrier correctement appliqué"
        },
        "first step": {
          "content": "Les plannings des véhicules se trouvent sur la page Véhicules, tandis que ceux des conducteurs se trouvent sur la page Conducteurs.\n\nComme le processus est similaire sur les deux pages, pour ce tutoriel, sélectionnons la « <strong>page Véhicules</strong> » mise en évidence.",
          "title": "Calendrier des véhicules ou des conducteurs"
        },
        "fourth step": {
          "content": "Pour ce tutoriel, sélectionnons le premier véhicule du tableau en cliquant sur le bouton surligné.",
          "title": "Sélectionnez un véhicule"
        },
        "second step": {
          "content": "Comme le processus est similaire sur les deux pages, pour ce tutoriel, sélectionnons la « <strong>page Véhicules</strong> » mise en évidence.",
          "title": "Page Véhicules"
        },
        "seventh step": {
          "content": "Une fois que vous avez sélectionné un planning, le bouton « <strong>Appliquer</strong> » mis en surbrillance devient actif. Cliquez dessus pour appliquer le planning au véhicule sélectionné.\n\nCliquez sur « <strong>Suivant</strong> » pour continuer.",
          "title": "Sélectionnez un calendrier à appliquer"
        },
        "sixth step": {
          "content": "Après avoir sélectionné le véhicule, vous pouvez choisir un calendrier à appliquer en cliquant dessus.\n\nCliquez sur « <strong>Suivant</strong> » pour continuer",
          "title": "Sélectionnez un calendrier à appliquer"
        },
        "third step": {
          "content": "Vous devez d'abord sélectionner un ou plusieurs véhicules avant de leur appliquer un planning.\nPour commencer, cliquez sur le bouton « <strong>Sélectionner les lignes</strong> » mis en évidence.",
          "title": "Ouvrir l'outil de sélection"
        }
      },
      "name": "Appliquer le calendrier"
    },
    "company selector": {
      "desktop": {
        "first step": {
          "content": "Dans le menu supérieur, le sélecteur d'entreprise vous permet de choisir l'entreprise avec laquelle vous souhaitez interagir dans TachoSync.\nCette fonction est nécessaire lorsque vous gérez plusieurs entreprises.\n\nCliquez sur le bouton <strong>surligné</strong> pour ouvrir le sélecteur d'entreprise.",
          "title": "Ouvrir le sélecteur d'entreprise"
        },
        "second step": {
          "content": "L'écran de sélection des entreprises vous permet de choisir une entreprise spécifique avec laquelle travailler. Dans les autres menus, vous ne verrez que les ressources liées à l'entreprise sélectionnée. Lorsque vous vous déconnectez de TachoSync, la dernière sélection utilisée est toujours enregistrée.",
          "title": "Sélecteur d'entreprise"
        }
      },
      "mobile": {
        "first step": {
          "content": "Dans le menu supérieur, le sélecteur d'entreprise vous permet de choisir l'entreprise avec laquelle vous souhaitez interagir dans TachoSync.\nCette fonction est nécessaire lorsque vous gérez plusieurs entreprises.\n\nCliquez sur le bouton <strong>surligné</strong> pour ouvrir le sélecteur d'entreprise.",
          "title": "Ouvrir le sélecteur d'entreprise"
        },
        "second step": {
          "content": "L'écran de sélection des entreprises vous permet de choisir une entreprise spécifique avec laquelle travailler. Dans les autres menus, vous ne verrez que les ressources liées à l'entreprise sélectionnée. Lorsque vous vous déconnectez de TachoSync, la dernière sélection utilisée est toujours enregistrée.",
          "title": "Sélecteur d'entreprise"
        }
      },
      "name": "Sélecteur d'entreprise"
    },
    "create schedule": {
      "desktop": {
        "fifth step": {
          "content": "Une fois un planning créé, il doit être appliqué aux véhicules ou aux conducteurs sélectionnés. Consultez le tutoriel « <strong>Appliquer </strong>un planning » pour savoir comment procéder.\n\nCliquez sur « <strong>Suivant</strong> » pour continuer.",
          "title": "Calendrier non appliqué"
        },
        "final step": {
          "content": "Félicitations, vous avez appris à créer un planning.\n\nApprenez ensuite à appliquer un planning à des éléments sélectionnés.\n\nCliquez sur « <strong>Terminer</strong> » pour terminer le tutoriel.",
          "title": "Créer un planning - terminé"
        },
        "first step": {
          "content": "Un calendrier est un programme prédéfini qui télécharge automatiquement les données du tachygraphe de vos véhicules ou de vos conducteurs à des moments et à des intervalles précis. En définissant une date de début, une heure et une fréquence (par exemple, quotidiennement), le calendrier garantit une collecte régulière des données sans intervention manuelle.\n\nCliquez sur «<strong> Commencer</strong> » pour démarrer.",
          "title": "Qu'est-ce qu'un planning ?"
        },
        "fourth step": {
          "content": "Dans cet écran, vous pouvez créer, modifier, suspendre ou supprimer des plannings. La première place est toujours réservée au planning global, qui ne peut pas être supprimé.",
          "title": "Horaires"
        },
        "second step": {
          "content": "Les plannings des véhicules se trouvent sur la page « Véhicules ». Les plannings des conducteurs se trouvent sur la page « Conducteurs ».\n\nComme la procédure est similaire sur les deux pages, pour ce tutoriel, sélectionnez la page <strong>« Véhicules</strong> » mise en surbrillance.",
          "title": "Calendrier des véhicules ou des conducteurs"
        },
        "third step": {
          "content": "Un planning peut être créé et modifié à tout moment dans la fenêtre « Plannings », que des véhicules ou des conducteurs aient été ajoutés ou non.\n\nCliquez sur le bouton « <strong>Plannings</strong> » surligné pour continuer.",
          "title": "Horaires ouverts"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Dans cet écran, vous pouvez créer, modifier, suspendre ou supprimer n'importe quel planning créé. La première place est toujours réservée au planning global, qui ne peut pas être supprimé.",
          "title": "Horaires"
        },
        "final step": {
          "content": "Félicitations, vous avez appris à créer un planning.\n\nEnsuite, découvrez comment appliquer un planning à des éléments sélectionnés.\n\nCliquez sur « <strong>Terminer</strong> » pour terminer le tutoriel.",
          "title": "Créer un planning - terminé"
        },
        "first step": {
          "content": "Un calendrier est un programme prédéfini qui télécharge automatiquement les données du tachygraphe de vos véhicules ou de vos conducteurs à des moments et à des intervalles précis. En définissant une date de début, une heure et une fréquence (par exemple, quotidiennement), le calendrier garantit une collecte régulière des données sans intervention manuelle.\n\nCliquez sur «<strong> Commencer</strong> » pour démarrer.",
          "title": "Qu'est-ce qu'un planning ?"
        },
        "fourth step": {
          "content": "Un planning peut être créé et modifié à tout moment dans la fenêtre « Plannings », que des véhicules ou des conducteurs aient été ajoutés ou non.\n\nCliquez sur le bouton « <strong>Plannings</strong> » surligné pour continuer.",
          "title": "Horaires ouverts"
        },
        "second step": {
          "content": "Les plannings des véhicules se trouvent sur la page Véhicules, tandis que ceux des conducteurs se trouvent sur la page Conducteurs.\n\nPour accéder à ces pages, ouvrons d'abord le <strong>menu</strong>.",
          "title": "Calendrier des véhicules ou des conducteurs"
        },
        "sixth step": {
          "content": "Une fois le planning créé, il doit être appliqué aux véhicules ou aux conducteurs sélectionnés. La procédure à suivre est expliquée dans un autre tutoriel intitulé <strong>« Appliquer le planning</strong> ».\n\nCliquez sur « <strong>Suivant</strong> » pour continuer.",
          "title": "Calendrier non appliqué"
        },
        "third step": {
          "content": "Comme le processus est similaire sur les deux pages, pour ce tutoriel, sélectionnons la « <strong>page Véhicules </strong>» mise en évidence",
          "title": "Page Véhicules"
        }
      },
      "name": "Créer un planning"
    }
  }
}
